import axios from "axios";
import { idleMs } from "./activity"; // v3.4.509 — سياسة الجلسات
const API_BASE = (typeof window !== "undefined" ? window.location.origin : ""); // v3.4.482 — نفس العنوان المفتوح (نطاق DO أو erp.rael.com.sa)
const api = axios.create({ baseURL: API_BASE, withCredentials: true, headers: { "Content-Type": "application/json" } });

// v3.4.509 — كل طلب يحمل المدة منذ آخر تفاعل للمستخدم (الخادم يُنهي الجلسة بعد 30 دقيقة بلا نشاط)
api.interceptors.request.use((config) => { try { config.headers["X-Idle-Ms"] = String(idleMs()); } catch (_) { /* */ } return config; });
// الجلسة انتهت (خمول / مدة قصوى / دخول من جهاز آخر): توجيه لصفحة الدخول مع السبب — لصفحات نظام الموظفين فقط
let staffSeen = false, endingSession = false;
export const markStaffSession = (on) => { staffSeen = !!on; };
async function onUnauthorized(error) {
  if (!staffSeen || endingSession || typeof window === "undefined") return;
  if (/^\/(portal|pm|login|site|screen)(\/|$)/.test(window.location.pathname)) return;
  const url = String(error.config?.url || "");
  if (/\/auth\/(me|logout)/.test(url)) return;
  let code = error.response?.data?.code || "";
  if (!code) { // 401 بلا سبب: نتأكد أن الجلسة انتهت فعلًا (وليس خطأ صلاحية في خدمة خارجية)
    try { const r = await api.get("/auth/me"); if (r.data?.user) return; code = r.data?.session_ended || "session_ended"; } catch (_) { return; }
  }
  endingSession = true;
  window.location.replace("/login?error=" + encodeURIComponent(code));
}

// ── 429 Rate-Limit Protection: exponential backoff retry ──
api.interceptors.response.use(
  response => response,
  async (error) => {
    const config = error.config;
    if (error.response?.status === 401) onUnauthorized(error); // v3.4.509
    if (error.response?.status === 429 && (!config._retryCount || config._retryCount < 3)) {
      config._retryCount = (config._retryCount || 0) + 1;
      const delay = Math.min(1000 * Math.pow(2, config._retryCount), 8000); // 2s, 4s, 8s
      await new Promise(resolve => setTimeout(resolve, delay));
      return api(config);
    }
    return Promise.reject(error);
  }
);

export const auth = {
  getUser: () => api.get("/auth/me"),
  logout: () => api.post("/auth/logout"),
  loginUrl: `${API_BASE}/auth/google`,
  impersonate: (profile_id) => api.post("/auth/impersonate", { profile_id }),
  stopImpersonate: () => api.post("/auth/stop-impersonate"),
};
// v3.4.510 — التحقق بخطوتين (تطبيق المصادقة / رمز واتساب)
const TFA = "/api/auth/2fa";
export const twoFactor = {
  loginSend:     ()             => api.post(TFA + "/login/send"),
  loginVerify:   (method, code) => api.post(TFA + "/login/verify", { method, code }),
  enrollStart:   ()             => api.post(TFA + "/login/enroll/start"),
  enrollConfirm: (code)         => api.post(TFA + "/login/enroll/confirm", { code }),
  my:            ()             => api.get(TFA + "/my"),
  myStart:       (code)         => api.post(TFA + "/my/totp/start", { code }),
  myConfirm:     (code)         => api.post(TFA + "/my/totp/confirm", { code }),
  myDisable:     (code)         => api.post(TFA + "/my/totp/disable", { code }),
  myBackup:      (code)         => api.post(TFA + "/my/backup", { code }),
  admin:         ()             => api.get(TFA + "/admin"),
  setPolicy:     (mode)         => api.put(TFA + "/admin/policy", { mode }),
  setPhone:      (id, phone)    => api.put(TFA + "/admin/user/" + id + "/phone", { phone }),
  resetUser:     (id)           => api.post(TFA + "/admin/user/" + id + "/reset"),
  createTemplate: ()            => api.post(TFA + "/admin/template"),
  syncTemplate:  ()             => api.post(TFA + "/admin/template/sync"),
};

// v3.4.059 — نظام إرسال الدعوات
export const invitations = {
  listDesigns:   ()            => api.get("/api/invitations/designs"),
  uploadDesign:  (formData)    => api.post("/api/invitations/designs", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  updateDesign:  (id, data)    => api.put(`/api/invitations/designs/${id}`, data),
  deleteDesign:  (id)          => api.delete(`/api/invitations/designs/${id}`),
  audienceSources: ()          => api.get("/api/invitations/audience/sources"),
  audience:      (params)      => api.get("/api/invitations/audience", { params }),
  parseExcel:    (formData)    => api.post("/api/invitations/parse", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  batches:       ()            => api.get("/api/invitations/batches"),
  batch:         (id)          => api.get(`/api/invitations/batches/${id}`),
};

export const reservations = {
  list: (params = {}) => api.get("/api/reservations", { params }),
  health: () => api.get("/api/res-health"), // v3.4.143 — صحة الحجوزات
  // v3.3.715 — سجل تغييرات الحجز
  getAuditLog: (id) => api.get(`/api/reservations/${id}/audit-log`),
  distinctValues: (column, params) => api.get("/api/reservations/distinct/" + column, { params }), // v3.3.999 — تمرير فلاتر الشبكة للتسلسل
  get: (id) => api.get(`/api/reservations/${id}`),
  // v3.3.751 — الوحدات المرتبطة بالحجز من طرف الوحدة
  getLinkedUnits: (id) => api.get(`/api/reservations/${id}/linked-units`),
  unitQuotations: (params) => api.get("/api/reservations/unit-quotations", { params }), // v3.4.601 — عروض السعر لوحدة الحجز
  quotation: (id) => api.get(`/api/reservations/quotation/${id}`), // v3.4.607 — عرض واحد لتعبئة حجز جديد («تحويل إلى حجز»)
  projectQuotations: (project_id) => api.get("/api/reservations/project-quotations", { params: { project_id } }), // v3.4.607 — العروض السارية على وحدات المشروع
  create: (data) => api.post("/api/reservations", data),
  update: (id, data) => api.put(`/api/reservations/${id}`, data),
  delete: (id) => api.delete(`/api/reservations/${id}`),
  stats: (params) => api.get("/api/reservations/stats", { params }),
  statistics: (params) => api.get("/api/reservations/statistics", { params }), // v3.4.690 — إحصائيات الحجوزات (شركة/خارجية، شهري، مدة الإكمال)
  exportAll: () => api.get("/api/reservations/export/csv"),
  importBulk: (rows) => api.post("/api/reservations/import", { rows }),
  // Payments API - الدفعات المسددة
  getPayments: (id) => api.get(`/api/reservations/${id}/payments`),
  addPayment: (id, data) => api.post(`/api/reservations/${id}/payments`, data),
  deletePayment: (id, paymentId) => api.delete(`/api/reservations/${id}/payments/${paymentId}`),
  // Scheduled Payments API - الدفعات المتفق عليها
  getScheduledPayments: (id) => api.get(`/api/reservations/${id}/scheduled-payments`),
  addScheduledPayment: (id, data) => api.post(`/api/reservations/${id}/scheduled-payments`, data),
  deleteScheduledPayment: (id, spId) => api.delete(`/api/reservations/${id}/scheduled-payments/${spId}`),
  markScheduledPaymentPaid: (id, spId) => api.put(`/api/reservations/${id}/scheduled-payments/${spId}/mark-paid`),
  // v3.3.458 — Reverse the mark-paid action
  unmarkScheduledPaymentPaid: (id, spId) => api.put(`/api/reservations/${id}/scheduled-payments/${spId}/unmark-paid`),
  // v3.3.373 — ملاحظات الحجز التراكمية
  listNotes: (id) => api.get(`/api/reservations/${id}/notes`),
  addNote: (id, note_text) => api.post(`/api/reservations/${id}/notes`, { note_text }),
  deleteNote: (id, noteId) => api.delete(`/api/reservations/${id}/notes/${noteId}`),
};

export const users = {
  list: () => api.get("/api/users"),
  invite: (email, permissions) => api.post("/api/users/invite", { email, permissions }),
  updatePermissions: (id, permissions) => api.put(`/api/users/${id}/permissions`, { permissions }),
  updateRole: (id, role) => api.put(`/api/users/${id}/role`, { role }),
  updateStatus: (id, is_active) => api.put(`/api/users/${id}/status`, { is_active }),
  setWaPhone: (id, wa_phone) => api.put(`/api/users/${id}/wa-phone`, { wa_phone }), // v3.4.728 — جوال واتساب الموظف
  remove: (id) => api.delete(`/api/users/${id}`),
};

export const profiles = {
  list: () => api.get("/api/profiles"),
  get: (id) => api.get(`/api/profiles/${id}`),
  create: (data) => api.post("/api/profiles", data),
  update: (id, data) => api.put(`/api/profiles/${id}`, data),
  delete: (id) => api.delete(`/api/profiles/${id}`),
  assign: (profileId, userId) => api.put(`/api/profiles/${profileId}/assign`, { user_id: userId }),
  unassign: (profileId, userId) => api.put(`/api/profiles/${profileId}/unassign`, { user_id: userId }),
  sync: (profileId) => api.post(`/api/profiles/${profileId}/sync`),
  getViewScopes: () => api.get("/api/profiles/meta/view-scopes"),
  // v3.3.419 — Permissions matrix export/import
  exportMatrix: async () => {
    const r = await api.get("/api/profiles/matrix/export", { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = `permissions_matrix_${new Date().toISOString().slice(0, 10)}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
  importMatrix: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/api/profiles/matrix/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
  },
};

export const ref = {
  getClients: () => api.get("/api/ref/clients"),
  addClient: (data) => api.post("/api/ref/clients", data),
  // v3.3.741 موجود أسفل الملف: addWithDupGuard — استخدمه عند الإضافة اليدوية
  deleteClient: (id) => api.delete(`/api/ref/clients/${id}`),
  getDevelopers: () => api.get("/api/ref/developers"),
  addDeveloper: (data) => api.post("/api/ref/developers", data),
  deleteDeveloper: (id) => api.delete(`/api/ref/developers/${id}`),
  getMarketers: () => api.get("/api/ref/marketers"),
  addMarketer: (data) => api.post("/api/ref/marketers", data),
  deleteMarketer: (id) => api.delete(`/api/ref/marketers/${id}`),
  bulkAddClients: (rows) => api.post('/api/ref/clients/bulk', { rows }),
  updateClient: (id, data) => api.put(`/api/ref/clients/${id}`, data),
  bulkAddDevelopers: (rows) => api.post('/api/ref/developers/bulk', { rows }),
  updateDeveloper: (id, data) => api.put(`/api/ref/developers/${id}`, data),
  bulkAddMarketers: (rows) => api.post('/api/ref/marketers/bulk', { rows }),
  updateMarketer: (id, data) => api.put(`/api/ref/marketers/${id}`, data),
  mergeMarketer: (id, data) => api.post(`/api/ref/marketers/${id}/merge`, data), // v3.4.743 — دمج في مسوق آخر
  getOptions: () => api.get("/api/ref/options"),
  getAllOptions: () => api.get("/api/ref/options/all"),
  getClientStats: (id) => api.get(`/api/ref/clients/${id}/stats`),
  getClientsQuality: () => api.get("/api/ref/clients/quality"), // v3.4.140 — جودة بيانات العملاء
  getClientUnits: (id) => api.get(`/api/ref/clients/${id}/units`),
  addOption: (category, label, color, group_name) => api.post("/api/ref/options", { category, label, color, group_name }), // v3.3.784 — مجموعة اختيارية
  updateOption: (id, data) => api.put(`/api/ref/options/${id}`, data),
  deleteOption: (id) => api.delete(`/api/ref/options/${id}`),
  getProjectsList: () => api.get("/api/ref/projects-list"),
};

// v3.4.817 — Alma Capital: رسائل الموقع + بيانات التواصل + الالتزام التنظيمي (CMA)
export const alma = {
  messages: (params) => api.get("/api/alma/messages", { params }),
  updateMessage: (id, d) => api.put(`/api/alma/messages/${id}`, d),
  deleteMessage: (id) => api.delete(`/api/alma/messages/${id}`),
  settings: () => api.get("/api/alma/settings"),
  saveSettings: (d) => api.put("/api/alma/settings", d),
  compliance: () => api.get("/api/alma/compliance"),
  saveCompliance: (key, d) => api.put(`/api/alma/compliance/${key}`, d),
  verifyCompliance: (key) => api.post(`/api/alma/compliance/${key}/verify`, {}, { timeout: 60000 }), // v3.4.825 — تحقق آلي من الموقع الحي
  verifyAllCompliance: () => api.post("/api/alma/compliance/verify-all", {}, { timeout: 120000 }),
  // v3.4.827 — الأشخاص (مجلس الإدارة / كبار التنفيذيين) بالصور
  people: () => api.get("/api/alma/people"),
  createPerson: (d) => api.post("/api/alma/people", d),
  updatePerson: (id, d) => api.put(`/api/alma/people/${id}`, d),
  deletePerson: (id) => api.delete(`/api/alma/people/${id}`),
  // v3.4.828 — متابعة متطلبات بدء ممارسة العمل (CMA)
  startupReqs: () => api.get("/api/alma/startup-reqs"),
  createStartupReq: (d) => api.post("/api/alma/startup-reqs", d),
  updateStartupReq: (id, d) => api.put(`/api/alma/startup-reqs/${id}`, d),
  deleteStartupReq: (id) => api.delete(`/api/alma/startup-reqs/${id}`),
  startupReqDoc: (id) => api.get(`/api/alma/startup-reqs/${id}/doc`, { responseType: "blob" }),
  addStartupItem: (id, text) => api.post(`/api/alma/startup-reqs/${id}/items`, { text }), // v3.4.831 — النقاط الفرعية
  updateStartupItem: (id, iid, d) => api.put(`/api/alma/startup-reqs/${id}/items/${iid}`, d),
  deleteStartupItem: (id, iid) => api.delete(`/api/alma/startup-reqs/${id}/items/${iid}`),
  // v3.4.829 — محتوى الموقع الإلكتروني (كل النصوص قابلة للتعديل)
  siteContent: () => api.get("/api/alma/content"),
  saveSiteContent: (items) => api.put("/api/alma/content", { items }),
};

export default api;

// v3.3.769 — إدارة حسابات البوابة الخارجية (من داخل النظام الرئيسي)
// v3.4.192 — الموارد البشرية
// v3.4.837 — إدارة الرواتب (تحت التحليل المالي)
export const payroll = {
  month:             (params)     => api.get("/api/payroll/month", { params }),
  employee:          (id, params) => api.get(`/api/payroll/employees/${id}`, { params }),
  saveSalary:        (id, d)      => api.post(`/api/payroll/employees/${id}/salary`, d),
  deleteSalary:      (vid)        => api.delete(`/api/payroll/salary-versions/${vid}`),
  createLoan:        (id, d)      => api.post(`/api/payroll/employees/${id}/loans`, d),
  updateLoan:        (lid, d)     => api.put(`/api/payroll/loans/${lid}`, d),
  deleteLoan:        (lid)        => api.delete(`/api/payroll/loans/${lid}`),
  addInstallment:    (lid, d)     => api.post(`/api/payroll/loans/${lid}/installments`, d),
  updateInstallment: (iid, d)     => api.put(`/api/payroll/loan-installments/${iid}`, d),
};
export const hr = {
  settings:        ()          => api.get("/api/hr/settings"),
  dashboard:       ()          => api.get("/api/hr/dashboard"), // v3.4.266
  // v3.4.307 — مجموعات الموظفين + الإعلانات الإدارية
  groups:          ()          => api.get("/api/hr/groups"),
  createGroup:     (d)         => api.post("/api/hr/groups", d),
  updateGroup:     (id, d)     => api.put(`/api/hr/groups/${id}`, d),
  deleteGroup:     (id)        => api.delete(`/api/hr/groups/${id}`),
  announcements:   ()          => api.get("/api/hr/announcements"),
  createAnnouncement: (d)      => api.post("/api/hr/announcements", d),
  updateAnnouncement: (id, d)  => api.put(`/api/hr/announcements/${id}`, d),
  deleteAnnouncement: (id)     => api.delete(`/api/hr/announcements/${id}`),
  holidays:        ()          => api.get("/api/hr/holidays"), // v3.4.272
  createHoliday:   (d)         => api.post("/api/hr/holidays", d),
  updateHoliday:   (id, d)     => api.put(`/api/hr/holidays/${id}`, d),
  deleteHoliday:   (id)        => api.delete(`/api/hr/holidays/${id}`),
  saveSettings:    (d)         => api.put("/api/hr/settings", d),
  accounts:        ()          => api.get("/api/hr/accounts"),
  locations:       ()          => api.get("/api/hr/locations"),
  createLocation:  (d)         => api.post("/api/hr/locations", d),
  updateLocation:  (id, d)     => api.put(`/api/hr/locations/${id}`, d),
  deleteLocation:  (id)        => api.delete(`/api/hr/locations/${id}`),
  schedules:       ()          => api.get("/api/hr/schedules"), // v3.4.195
  createSchedule:  (d)         => api.post("/api/hr/schedules", d),
  updateSchedule:  (id, d)     => api.put(`/api/hr/schedules/${id}`, d),
  deleteSchedule:  (id)        => api.delete(`/api/hr/schedules/${id}`),
  employees:       ()          => api.get("/api/hr/employees"),
  createEmployee:  (d)         => api.post("/api/hr/employees", d),
  updateEmployee:  (id, d)     => api.put(`/api/hr/employees/${id}`, d),
  deleteEmployee:  (id)        => api.delete(`/api/hr/employees/${id}`),
  resetBiometrics: (id)        => api.delete(`/api/hr/employees/${id}/biometrics`), // v3.4.200
  orgChart:        ()          => api.get("/api/hr/org-chart"), // v3.4.824 — الهيكل الإداري
  setManager:      (id, d)     => api.put(`/api/hr/employees/${id}/manager`, d),
  attendance:      (params)    => api.get("/api/hr/attendance", { params }),
  manualAttendance:(d)         => api.post("/api/hr/attendance", d),
  deleteAttendance:(id)        => api.delete(`/api/hr/attendance/${id}`),
  requests:        (params)    => api.get("/api/hr/requests", { params }),
  decideRequest:   (id, d)     => api.put(`/api/hr/requests/${id}/decide`, d),
  createRequest:   (d)         => api.post("/api/hr/requests", d),
  // v3.4.198 — أنواع الطلبات + المستندات + تغيير النوع
  requestTypes:    ()          => api.get("/api/hr/request-types"),
  runUnexcused:    ()          => api.post("/api/hr/unexcused/run"), // v3.4.596 — فحص «غياب بدون إذن» الآن
  reminders:       (date)      => api.get("/api/hr/reminders", { params: date ? { date } : {} }), // v3.4.844 — سجل تذكير الحضور/الانصراف
  testReminder:    (d)         => api.post("/api/hr/reminders/test", d), // v3.4.844 — {employee_id, kind}
  createRequestType:(d)        => api.post("/api/hr/request-types", d),
  updateRequestType:(id, d)    => api.put(`/api/hr/request-types/${id}`, d),
  deleteRequestType:(id)       => api.delete(`/api/hr/request-types/${id}`),
  changeRequestType:(id, d)    => api.put(`/api/hr/requests/${id}/type`, d),
  uploadRequestDocument:(id, d)=> api.post(`/api/hr/requests/${id}/document`, d),
  requestDocument: (id)        => api.get(`/api/hr/requests/${id}/document`, { responseType: "blob" }),
  balances:        (params)    => api.get("/api/hr/balances", { params }),
  adjustment:      (d)         => api.post("/api/hr/adjustments", d),
  report:          (params)    => api.get("/api/hr/report", { params }),
  deductions:      (params)    => api.get("/api/hr/deductions", { params }), // v3.4.736 — سجل الخصومات والجزاءات
};

export const portalAdmin = {
  listAccounts: () => api.get("/api/portal/accounts"),
  setPassword: (id, d) => api.post(`/api/portal/accounts/${id}/password`, d), // v3.4.491 — مع خيار الإرسال على واتساب
  systemUsers: () => api.get("/api/portal/accounts/system-users"), // v3.4.465
  directory: () => api.get("/api/portal/accounts/directory"), // v3.4.201 — دليل مخفّف لغير الأدمن (المحتملين / الكول سنتر)
  createAccount: (data) => api.post("/api/portal/accounts", data),
  updateAccount: (id, data) => api.put(`/api/portal/accounts/${id}`, data),
  deleteAccount: (id) => api.delete(`/api/portal/accounts/${id}`),
  previewToken: (id) => api.post(`/api/portal/accounts/${id}/preview-token`), // v3.4.160 — معاينة التطبيق كما يراه الحساب
  waNumbers: () => api.get("/api/portal/wa-numbers"), // v3.4.061 — أرقام البزنس شات للإسناد
  setOfficialWa: (display_number) => api.put("/api/portal/wa-numbers/official", { display_number }), // v3.4.093 — الرقم الرسمي المشترك
  // v3.3.806 — إحصائيات المناديب + شات المناديب
  repsStats: (view, month) => api.get("/api/portal/reps/stats", { params: { view, month } }),
  marketersStats: (view, month) => api.get("/api/portal/marketers/stats", { params: { view, month } }), // v3.3.942
  repsChats: () => api.get("/api/portal/reps/chats"),
  repChat: (id, since) => api.get(`/api/portal/reps/${id}/chat`, { params: { since: since || 0 } }),
  repSend: (id, body) => api.post(`/api/portal/reps/${id}/chat`, { body }),
  activityReport: (from, to) => api.get("/api/portal/activity-report", { params: { from, to }, timeout: 180000 }), // v3.4.795 — تقرير ملخص نشاط المسوّقين
  adminCallStats: (refresh, date) => api.get("/api/portal/admin-call-stats", { params: { ...(refresh ? { refresh: 1 } : {}), ...(date ? { date } : {}) } }), // v3.4.440 — مكالمات اليوم لكل تحويلة — v3.4.552: يوم محدد
  adminDashboard: (days, date) => api.get("/api/portal/admin-dashboard", { params: { days, ...(date ? { date } : {}) } }), // v3.4.552: date = بنهاية يوم محدد
  permissions: () => api.get("/api/portal/permissions"), // v3.4.454 — لوحة صلاحيات المنظم التسويقي
  savePermissionDefaults: (defaults) => api.put("/api/portal/permissions/defaults", { defaults }),
  setAccountFeatures: (id, overrides) => api.put(`/api/portal/accounts/${id}/features`, { overrides }), // v3.4.228 — داشبورد الإدارة
};

// v3.3.979 — إدارة حسابات تطبيق إدارة المشاريع (من النظام الرئيسي)
export const pmAdmin = {
  listAccounts: () => api.get("/api/pm/accounts"),
  createAccount: (data) => api.post("/api/pm/accounts", data),
  updateAccount: (id, data) => api.put(`/api/pm/accounts/${id}`, data),
  deleteAccount: (id) => api.delete(`/api/pm/accounts/${id}`),
  permissions: () => api.get("/api/pm/permissions"), // v3.4.466
  savePermissionDefaults: (defaults) => api.put("/api/pm/permissions/defaults", { defaults }),
  setAccountFeatures: (id, overrides) => api.put(`/api/pm/accounts/${id}/features`, { overrides }),
};

// v3.3.759 — تحليل التسويق الداخلي
export const marketingAnalytics = {
  overview: (params = {}) => api.get("/api/marketing-analytics/overview", { params }),
  marketer: (id, params = {}) => api.get(`/api/marketing-analytics/marketer/${id}`, { params }),
  setSalary: (id, monthly_salary) => api.put(`/api/marketing-analytics/marketers/${id}/salary`, { monthly_salary }),
  listExpenses: (params = {}) => api.get("/api/marketing-analytics/expenses", { params }),
  addExpense: (data) => api.post("/api/marketing-analytics/expenses", data),
  deleteExpense: (id) => api.delete(`/api/marketing-analytics/expenses/${id}`),
};

export const audit = {
  list: (params = {}) => api.get("/api/audit", { params }),
  stats: () => api.get("/api/audit/stats"),
  filters: () => api.get("/api/audit/filters"),
};

// ══════════════════════════════════════════════════════════════
// Recycle Bin API - سلة المهملات (v3.3.544)
// ══════════════════════════════════════════════════════════════
export const recycleBin = {
  list: (params = {}) => api.get("/api/recycle-bin", { params }),
  get: (id) => api.get(`/api/recycle-bin/${id}`),
  restore: (id) => api.post(`/api/recycle-bin/${id}/restore`),
  purge: (id) => api.delete(`/api/recycle-bin/${id}`),
  purgeAll: () => api.post("/api/recycle-bin/purge-all", { confirm: true }),
  autoPurge: () => api.post("/api/recycle-bin/auto-purge"),
  getSettings: () => api.get("/api/recycle-bin/settings"),
  setSettings: (retention_days) => api.put("/api/recycle-bin/settings", { retention_days }),
};

// ══════════════════════════════════════════════════════════════
// Login History API - سجل تسجيل الدخول (v3.3.546)
// v3.3.547 — Added timeline endpoint
// ══════════════════════════════════════════════════════════════
export const loginHistory = {
  list: (params = {}) => api.get("/api/login-history", { params }),
  stats: () => api.get("/api/login-history/stats"),
  timeline: (sessionId) => api.get(`/api/login-history/${sessionId}/timeline`),
};

// ══════════════════════════════════════════════════════════════
// Security Self-Assessment API - تقييم الأمن السيبراني (v3.3.553)
// ══════════════════════════════════════════════════════════════
export const security = {
  getChecklist:    ()           => api.get("/api/security/checklist"),
  runAutomated:    ()           => api.post("/api/security/run-automated"),
  getLatest:       ()           => api.get("/api/security/latest"),
  getHistory:      ()           => api.get("/api/security/history"),
  save:            (data)       => api.post("/api/security/save", data),
};

// ══════════════════════════════════════════════════════════════
// Communication API - التواصل عبر واتساب وسير العمل
// ══════════════════════════════════════════════════════════════
export const communication = {
  // Logs - سجل الرسائل
  getLogs: (params = {}) => api.get("/api/communication/logs", { params }),
  createLog: (data) => api.post("/api/communication/logs", data),
  createBulkLogs: (logs) => api.post("/api/communication/logs/bulk", { logs }),
  updateLogStatus: (id, status, notes) => api.put(`/api/communication/logs/${id}/status`, { status, notes }),
  
  // Workflows - سير العمل
  getWorkflows: (params = {}) => api.get("/api/communication/workflows", { params }),
  getWorkflowStats: () => api.get("/api/communication/workflows/stats"),
  createWorkflow: (data) => api.post("/api/communication/workflows", data),
  updateWorkflow: (id, data) => api.put(`/api/communication/workflows/${id}`, data),
  advanceWorkflow: (id, stage, notes) => api.put(`/api/communication/workflows/${id}/stage`, { stage, notes }),
  deleteWorkflow: (id) => api.delete(`/api/communication/workflows/${id}`),
  
  // Templates - قوالب الرسائل
  getTemplates: (category) => api.get("/api/communication/templates", { params: category ? { category } : {} }),
  getAllTemplates: () => api.get("/api/communication/templates/all"),
  createTemplate: (data) => api.post("/api/communication/templates", data),
  updateTemplate: (id, data) => api.put(`/api/communication/templates/${id}`, data),
  deleteTemplate: (id) => api.delete(`/api/communication/templates/${id}`),
  
  // Dashboard - لوحة المعلومات
  getDashboard: () => api.get("/api/communication/dashboard"),
};

// ══════════════════════════════════════════════════════════════
// WhatsApp Proxy API — كل الطلبات تمر عبر الباك إند
// WA Server structure: /session/:id/...  body uses {phone, message}
// ══════════════════════════════════════════════════════════════
export const whatsapp = {
  // حالة الاتصال → { connected, status, phone, label }
  getStatus: (session) =>
    api.get(`/api/whatsapp/${session}/status`),

  // قائمة المحادثات (قد تكون فارغة إذا فشل Puppeteer)
  getChats: (session) =>
    api.get(`/api/whatsapp/${session}/chats`),

  // أعضاء جروب واتساب
  getGroupParticipants: (session, groupId) =>
    api.get(`/api/whatsapp/${session}/group/${encodeURIComponent(groupId)}/participants`),

  // كل رسائل الـ session
  getAllMessages: (session) =>
    api.get(`/api/whatsapp/${session}/messages`),

  // رسائل شخص معين — الباك إند يفلتر
  getMessages: (session, phone, limit = 60) =>
    api.get(`/api/whatsapp/${session}/chats/${encodeURIComponent(phone)}/messages`, { params: { limit } }),

  // إرسال نص — body: { phone, message }
  sendMessage: (session, phone, message, meta = {}) =>
    api.post(`/api/whatsapp/${session}/send`, { phone, message, ...meta }),

  // إرسال ملف — multipart
  sendFile: (session, formData) =>
    api.post(`/api/whatsapp/${session}/send-file`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  // إرسال ملف من Drive مباشرة (بدون تحميل في الفرونت)
  sendDriveFile: (session, payload) =>
    api.post(`/api/whatsapp/${session}/send-drive-file`, payload),

  // بث جماعي — الباك إند يرسل تسلسلياً
  broadcast: (session, recipients, message) =>
    api.post(`/api/whatsapp/${session}/broadcast`, { recipients, message }),

  // سجل الرسائل
  getLogs: (params = {}) =>
    api.get("/api/whatsapp/logs", { params }),

  // QR Code للربط
  getQR: (session) =>
    api.get(`/api/whatsapp/${session}/qr`),

  // فصل الرقم
  disconnect: (session) =>
    api.post(`/api/whatsapp/${session}/disconnect`),

  // إعادة تشغيل الجلسة
  restart: (session) =>
    api.post(`/api/whatsapp/${session}/restart`),

  // v3.4.151 — الربط برقم الجوال ورمز اقتران
  requestPairingCode: (session, phone) => api.post(`/api/whatsapp/${session}/pairing-code`, { phone }, { timeout: 45000 }),
  pairingStatus: (session) => api.get(`/api/whatsapp/${session}/pairing-status`),
  // v3.4.046 — تنظيف عميق: قتل كروم الجلسة العالق + مسح الأقفال + إعادة البناء (لحالة «No QR available»)
  deepClean: (session) =>
    api.post(`/api/whatsapp/${session}/deep-clean`, {}, { timeout: 120000 }),
  // v3.4.288 — سجل عملية الربط (سيرفر واتساب + النظام + المتصفح)
  linkLog: (session, limit = 150) => api.get(`/api/whatsapp/${session}/link-log`, { params: { limit }, timeout: 20000 }),
  linkLogPost: (session, d) => api.post(`/api/whatsapp/${session}/link-log`, d),
  linkLogClear: (session) => api.delete(`/api/whatsapp/${session}/link-log`),

  // حالة العداد اليومي
  getDailyStatus: () =>
    api.get(`/api/whatsapp/daily-status`),

  // v3.3.599 — تعديل الحد اليومي (أدمن/صلاحية الإعدادات)
  setDailyLimit: (limit) =>
    api.put(`/api/whatsapp/daily-limit`, { limit }),

  // ─── Inbox (محلي من DB) ──────────────────────────────────────
  // مزامنة الرسائل من WA Server إلى DB
  sync: (session) =>
    api.post(`/api/whatsapp/${session}/sync`),

  // حالة المزامنة
  getSyncStatus: (session) =>
    api.get(`/api/whatsapp/${session}/sync-status`),

  // قائمة المحادثات من DB
  getInbox: (session) =>
    api.get(`/api/whatsapp/${session}/inbox`),

  // رسائل شخص معين من DB
  getInboxMessages: (session, phone, limit = 100) =>
    api.get(`/api/whatsapp/${session}/inbox/${encodeURIComponent(phone)}/messages`, { params: { limit } }),

  // ─── Media ──────────────────────────────────────────────────
  // تحميل ميديا كـ base64 JSON
  getMedia: (session, msgId) =>
    api.get(`/api/whatsapp/${session}/media/${encodeURIComponent(msgId)}`),

  // رابط تحميل الميديا كملف binary
  getMediaFileUrl: (session, msgId) =>
    `${api.defaults.baseURL}/api/whatsapp/${session}/media/${encodeURIComponent(msgId)}/file`,

  // ─── Chat History (مباشر من واتساب) ─────────────────────
  getChatHistory: (session, phone, limit = 50) =>
    api.get(`/api/whatsapp/${session}/chat-history/${encodeURIComponent(phone)}`, { params: { limit } }),

  // ─── Full Crawl (سحب كل المحادثات التاريخية) ────────────
  startFullCrawl: (session) =>
    api.post(`/api/whatsapp/${session}/full-crawl`),

  getCrawlStatus: (session) =>
    api.get(`/api/whatsapp/${session}/full-crawl/status`),
};

// v3.4.128 — محتوى الشاشة التفاعلية لكل مشروع
export const screenMedia = {
  get:         (pid)            => api.get(`/api/screen-media/project/${pid}`),
  upload:      (pid, fd, onUp)  => api.post(`/api/screen-media/project/${pid}/upload`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0, onUploadProgress: onUp }),
  update:      (id, data)       => api.put(`/api/screen-media/item/${id}`, data),
  remove:      (id)             => api.delete(`/api/screen-media/item/${id}`),
  reorder:     (pid, ids)       => api.put(`/api/screen-media/project/${pid}/reorder`, { ids }),
  setLocation: (pid, lat, lng)  => api.put(`/api/screen-media/project/${pid}/location`, { lat, lng }),
  setEnabled:  (pid, enabled)   => api.put(`/api/screen-media/project/${pid}/enabled`, { enabled }),
  // v3.4.130 — استيراد المحتوى المضمّن حاليًا في الشاشة إلى Drive والتبويب
  importDefaults: (pid, force)  => api.post(`/api/screen-media/project/${pid}/import-defaults`, { force: !!force }),
  importStatus:   (pid)         => api.get(`/api/screen-media/project/${pid}/import-status`),
  // v3.4.492 — الشاشة الموحّدة
  overview:       ()            => api.get("/api/screen-media/admin/overview"),
  order:          (ids)         => api.put("/api/screen-media/admin/order", { ids }),
  setMeta:        (pid, d)      => api.put(`/api/screen-media/project/${pid}/meta`, d),
};

// v3.4.561 — عروض الأسعار
// v3.4.611 — سندات القبض والصرف (دفترة)
export const vouchers = {
  settings: () => api.get("/api/vouchers/settings"),
  saveSettings: (d) => api.put("/api/vouchers/settings", d),
  daftraOptions: (refresh) => api.get("/api/vouchers/daftra/options", { params: refresh ? { refresh: 1 } : {} }),
  daftraImport: (type) => api.post("/api/vouchers/daftra/import", { type: type || "receipt" }), // v3.4.644 — v3.4.645 type
  list: (params = {}) => api.get("/api/vouchers", { params }),
  get: (id) => api.get(`/api/vouchers/${id}`),
  create: (d) => api.post("/api/vouchers", d),
  resend: (id) => api.post(`/api/vouchers/${id}/resend`),
  update: (id, d) => api.put(`/api/vouchers/${id}`, d), // v3.4.687 — تعديل قبل الاعتماد
  approve: (id) => api.post(`/api/vouchers/${id}/approve`), // v3.4.687 — اعتماد المحاسب
  cancel: (id, d) => api.post(`/api/vouchers/${id}/cancel`, d || {}),
  tafqeet: (amount) => api.get("/api/vouchers/tafqeet", { params: { amount } }),
  reservationLookup: (q) => api.get("/api/vouchers/reservation-lookup", { params: { q } }),
  quotationPrefill: (id) => api.get(`/api/vouchers/quotation-prefill/${id}`), // v3.4.617
  history: (params = {}) => api.get("/api/vouchers/history", { params }), // v3.4.618 — سجل النشاط
  historyExportLog: (d) => api.post("/api/vouchers/history/export-log", d),
  attachUnitPdf: (id) => api.post(`/api/vouchers/${id}/attach-unit-pdf`), // v3.4.623
};
export const quotations = {
  meta: () => api.get("/api/quotations/meta"),
  settings: () => api.get("/api/quotations/settings"), // v3.4.577 — إدارة نظام العروض
  saveSettings: (d) => api.put("/api/quotations/settings", d),
  units: (project_id, include_id) => api.get("/api/quotations/units", { params: { project_id, ...(include_id ? { include_id } : {}) } }),
  linkReservation: (quotation_id, reservation_id) => api.post(`/api/reservations/${reservation_id}/link-quotation`, { quotation_id }), // v3.4.642
  depositCandidates: (id, q) => api.get(`/api/quotations/${id}/deposit-candidates`, { params: q ? { q } : {} }), // v3.4.648
  linkDeposit: (id, voucher_id, replace) => api.post(`/api/quotations/${id}/link-deposit`, { voucher_id, replace: !!replace }), // v3.4.723 — replace: تغيير السند المربوط
  unlinkDeposit: (id) => api.post(`/api/quotations/${id}/unlink-deposit`),
  noDeposit: (id, on) => api.post(`/api/quotations/${id}/no-deposit`, { on: on !== false }), // v3.4.650
  reservationCandidates: (id, q) => api.get(`/api/quotations/${id}/reservation-candidates`, { params: q ? { q } : {} }),
  list: (params = {}) => api.get("/api/quotations", { params }),
  get: (id) => api.get(`/api/quotations/${id}`),
  create: (d) => api.post("/api/quotations", d),
  update: (id, d) => api.put(`/api/quotations/${id}`, d),
  submit: (id) => api.post(`/api/quotations/${id}/submit`),
  approve: (id, d) => api.post(`/api/quotations/${id}/approve`, d || {}),
  reject: (id, d) => api.post(`/api/quotations/${id}/reject`, d || {}),
  remove: (id) => api.delete(`/api/quotations/${id}`),
  share: (id) => api.post(`/api/quotations/${id}/share`), // v3.4.602 — رابط مشاركة العرض المعتمد مع العميل
  unshare: (id) => api.delete(`/api/quotations/${id}/share`),
  extend: (id, d) => api.post(`/api/quotations/${id}/extend`, d), // v3.4.607 — تمديد صلاحية العرض
  cancel: (id, d) => api.post(`/api/quotations/${id}/cancel`, d || {}), // v3.4.609 — إلغاء عرض ليُنشأ للوحدة عرض جديد
  redistribute: (id) => api.post(`/api/quotations/${id}/redistribute`), // v3.4.603 — توزيع الإجمالي على دفعات عرض محفوظ بالطريقة السابقة
};
export const projects = {
  list:           ()          => api.get("/api/projects"),
  get:            (id)        => api.get(`/api/projects/${id}`),
  create:         (data)      => api.post("/api/projects", data),
  update:         (id, data)  => api.put(`/api/projects/${id}`, data),
  updateCosts:    (id, data)  => api.patch(`/api/projects/${id}/costs`, data),
  delete:         (id)        => api.delete(`/api/projects/${id}`),
  bulkGenerate:   (id, data)  => api.post(`/api/projects/${id}/units/bulk-generate`, data),
  addUnit:        (id, data)  => api.post(`/api/projects/${id}/units`, data),
  updateUnit:     (uid, data) => api.put(`/api/projects/units/${uid}`, data),
  // v3.4.843 — سجل أسعار الوحدة
  unitPrices:     (uid)       => api.get(`/api/projects/units/${uid}/prices`),
  addUnitPrice:   (uid, data) => api.post(`/api/projects/units/${uid}/prices`, data),
  deleteUnitPrice:(uid, pid)  => api.delete(`/api/projects/units/${uid}/prices/${pid}`),
  // v3.3.378 — صفقة إعادة البيع
  updateResaleDeal: (uid, data) => api.patch(`/api/projects/units/${uid}/resale-deal`, data),
  unlinkResaleReservation: (uid) => api.delete(`/api/projects/units/${uid}/resale-deal/reservation`),
  removeResaleDoc: (uid, type) => api.delete(`/api/projects/units/${uid}/resale-deal/doc/${type}`),
  deleteUnit:     (uid)       => api.delete(`/api/projects/units/${uid}`),
  restoreUnit:    (uid)       => api.put(`/api/projects/units/${uid}/restore`),
  restoreAllUnits:(projectId) => api.post(`/api/projects/${projectId}/restore-all-units`),
  restoreUnitsBulk:(ids)      => api.post(`/api/projects/units/restore-bulk`, { ids }),
  getDeletedUnits:(projectId) => api.get(`/api/projects/${projectId}/deleted-units`),
  uploadDocument: (uid, fd)   => api.post(`/api/projects/units/${uid}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }),
  uploadUnitDocument: (uid, fd) => api.post(`/api/projects/units/${uid}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }),
  deleteDocument: (did)       => api.delete(`/api/projects/documents/${did}`),
  submitRequest:  (uid, data) => api.post(`/api/projects/units/${uid}/request`, data),
  searchReservations: (q, projectId) => api.get(`/api/projects/reservations/search?q=${encodeURIComponent(q)}${projectId ? `&project_id=${projectId}` : ''}`),
  // v3.3.571 — Project clients for the customer-update broadcast modal
  getProjectClients: (projectId) => api.get(`/api/projects/${projectId}/clients`),
  // v3.3.977 — سجل الرسائل الجماعية للعملاء
  clientBroadcasts: (projectId, audience) => api.get(`/api/projects/${projectId}/client-broadcasts`, { params: audience ? { audience } : {} }), // v3.4.051 — audience: clients | marketers
  saveClientBroadcast: (projectId, data) => api.post(`/api/projects/${projectId}/client-broadcasts`, data),
  pendingRequests:()          => api.get("/api/projects/requests/pending"),
  allRequests:    ()          => api.get("/api/projects/requests/all"),
  decide:         (id, decision, notes) => api.put(`/api/projects/requests/${id}/decide`, { decision, notes }),
  pendingCount:   ()          => api.get("/api/projects/requests/count"),
  // v3.4.111 — مراجعة الحجوزات المباعة (أدمن)
  soldReviews:      (status)  => api.get("/api/projects/sold-reviews/list", { params: { status: status || "pending" } }),
  soldReviewsCount: ()        => api.get("/api/projects/sold-reviews/count"),
  decideSoldReview: (id, decision, notes) => api.put(`/api/projects/sold-reviews/${id}/decide`, { decision, notes }),
  completenessSoldUnits: (params) => api.get("/api/completeness/sold-units", { params }), // v3.4.136 — فحص اكتمال المبيعات
  getLinkedReservation: (uid) => api.get(`/api/projects/units/${uid}/reservation-details`),
  // v3.3.697 — سجل حركات الوحدة
  getUnitAuditLog: (uid) => api.get(`/api/projects/units/${uid}/audit-log`),
  getReservationFullDetails: (resId) => api.get(`/api/projects/reservations/${resId}/full-details`),
  linkReservation: (uid, resId) => api.put(`/api/projects/units/${uid}/link-reservation`, { reservation_id: resId }),
  getBuildings: (projectId) => api.get(`/api/projects/${projectId}/buildings`),
  getUnitsForSelection: (projectId) => api.get(`/api/projects/${projectId}/units-for-selection`),
  generateBuilding: (projectId, data) => api.post(`/api/projects/${projectId}/buildings/generate`, data),
  confirmBuilding: (projectId, data) => api.post(`/api/projects/${projectId}/buildings/confirm`, data),
  deleteBuilding: (buildingId) => api.delete(`/api/projects/buildings/${buildingId}`),
  updateBuilding: (buildingId, data) => api.put(`/api/projects/buildings/${buildingId}`, data),
  bulkUpdateUnits: (projectId, units) => api.put(`/api/projects/${projectId}/units/bulk-update`, { units }),
  addUnits: (projectId, units) => api.post(`/api/projects/${projectId}/units/bulk-add`, { units }),
  // v3.4.058 — نسخ مشروع كامل (الهيكل فقط بدون بيانات البيع)
  duplicateProject: (projectId, data) => api.post(`/api/projects/${projectId}/duplicate`, data),
  deleteUnits: (projectId, unitIds) => api.post(`/api/projects/${projectId}/units/bulk-delete`, { unitIds }),
  // Unit Payments API - الدفعات المسددة للوحدة
  getUnitPayments: (unitId) => api.get(`/api/projects/units/${unitId}/payments`),
  addUnitPayment: (unitId, data) => api.post(`/api/projects/units/${unitId}/payments`, data),
  deleteUnitPayment: (unitId, paymentId) => api.delete(`/api/projects/units/${unitId}/payments/${paymentId}`),
  // Unit Scheduled Payments API - جدول الدفعات المتفق عليها
  getUnitScheduledPayments: (unitId) => api.get(`/api/projects/units/${unitId}/scheduled-payments`),
  addUnitScheduledPayment: (unitId, data) => api.post(`/api/projects/units/${unitId}/scheduled-payments`, data),
  deleteUnitScheduledPayment: (unitId, spId) => api.delete(`/api/projects/units/${unitId}/scheduled-payments/${spId}`),
  markScheduledPaymentPaid: (unitId, spId) => api.put(`/api/projects/units/${unitId}/scheduled-payments/${spId}/mark-paid`),
  // v3.3.458 — Reverse mark-paid
  unmarkScheduledPaymentPaid: (unitId, spId) => api.put(`/api/projects/units/${unitId}/scheduled-payments/${spId}/unmark-paid`),
  // v3.3.459 — Receipt management for unit payments
  uploadPaymentReceipt: (unitId, paymentId, formData) => api.post(
    `/api/projects/units/${unitId}/payments/${paymentId}/upload-receipt`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  ),
  removePaymentReceipt: (unitId, paymentId) => api.delete(`/api/projects/units/${unitId}/payments/${paymentId}/receipt`),
  updatePaymentAgreement: (unitId, agreement) => api.put(`/api/projects/units/${unitId}/payment-agreement`, { payment_agreement: agreement }),
  // Unit Transfers API - نقل/تنازل الوحدات
  getUnitTransfers: (unitId) => api.get(`/api/projects/units/${unitId}/transfers`),
  createUnitTransfer: (unitId, data) => api.post(`/api/projects/units/${unitId}/transfers`, data),
  updateUnitTransfer: (unitId, transferId, data) => api.put(`/api/projects/units/${unitId}/transfers/${transferId}`, data),
  executeUnitTransfer: (unitId, transferId) => api.post(`/api/projects/units/${unitId}/transfers/${transferId}/execute`),
  cancelUnitTransfer: (unitId, transferId) => api.post(`/api/projects/units/${unitId}/transfers/${transferId}/cancel`),
  // v3.3.722 — إبطال دورة مكتملة (تراجع) + حذف نهائي لدورة ملغاة
  annulUnitTransfer: (unitId, transferId) => api.post(`/api/projects/units/${unitId}/transfers/${transferId}/annul`),
  // v3.3.725 — تفعيل بيعة (transferId رقمي أو 'main' للبيعة الرئيسية)
  activateSale: (unitId, transferIdOrMain) => api.post(`/api/projects/units/${unitId}/transfers/${transferIdOrMain}/activate`),
  // v3.3.737 — تصفية البيعة الرئيسية
  updateMainLiquidation: (unitId, data) => api.patch(`/api/projects/units/${unitId}/main-liquidation`, data),
  setResalePublish: (unitId, published) => api.patch(`/api/projects/units/${unitId}/resale-publish`, { published }), // v3.3.793
  deleteUnitTransfer: (unitId, transferId) => api.delete(`/api/projects/units/${unitId}/transfers/${transferId}`),
  // Project Documents API
  getProjectDocuments: (projectId) => api.get(`/api/projects/${projectId}/documents`),
  reorderDocuments: (projectId, ids) => api.put(`/api/projects/${projectId}/documents/reorder`, { ids }), // v3.4.049 — ترتيب التحديثات
  addProjectDocument: (projectId, data) => api.post(`/api/projects/${projectId}/documents`, data),
  uploadProjectDocument: (projectId, fd) => api.post(`/api/projects/${projectId}/documents/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } }),
  updateProjectDocument: (projectId, docId, data) => api.patch(`/api/projects/${projectId}/documents/${docId}`, data),
  deleteProjectDocument: (projectId, docId) => api.delete(`/api/projects/${projectId}/documents/${docId}`),
  generateAvailabilityReport: (projectId, statuses, hiddenUnitIds, columnVisibility, reportSections) => api.post(`/api/projects/${projectId}/availability-report`, { statuses, hiddenUnitIds, columnVisibility, reportSections }),
  // v3.3.699 — كشف إعادة البيع
  generateResaleReport: (projectId) => api.post(`/api/projects/${projectId}/resale-report`),
  // v3.3.326
  saveMarketingHiddenUnits: (projectId, unitIds) => api.put(`/api/projects/${projectId}/marketing-hidden-units`, { unitIds }),
  // v3.3.334 — Marketing Templates
  getMarketingTemplates: (projectId) => api.get(`/api/projects/${projectId}/marketing-templates`),
  createMarketingTemplate: (projectId, data) => api.post(`/api/projects/${projectId}/marketing-templates`, data),
  updateMarketingTemplate: (projectId, id, data) => api.put(`/api/projects/${projectId}/marketing-templates/${id}`, data),
  deleteMarketingTemplate: (projectId, id) => api.delete(`/api/projects/${projectId}/marketing-templates/${id}`),
};

// ══════════════════════════════════════════════════════════════
// Disbursements API - صرف دلالات وإرجاع عرابين
// ══════════════════════════════════════════════════════════════
export const disbursements = {
  list: (params = {}) => api.get("/api/disbursements", { params }),
  stats: () => api.get("/api/disbursements/stats"),
  dueDalala: () => api.get("/api/disbursements/due-dalala"), // v3.4.142 — الدلالات المستحقة
  getReservations: (search) => api.get("/api/disbursements/reservations", { params: { search } }),
  create: (data) => api.post("/api/disbursements", data),
  approve: (id, status, notes) => api.put(`/api/disbursements/${id}/approve`, { status, notes }),
  execute: (id, data) => api.put(`/api/disbursements/${id}/execute`, data && typeof data === "object" ? data : { notes: data }), // v3.4.372 — {notes, payment_method, paid_at}
  updatePayment: (id, d) => api.put(`/api/disbursements/${id}/payment`, d), // v3.4.372
  resaleCycles: (params = {}) => api.get("/api/disbursements/resale-cycles", { params }), // v3.4.373 — عمليات إعادة البيع
  dueArboun: () => api.get("/api/disbursements/due-arboun"), // v3.4.373 — العرابين المستحقة الاسترداد
  resaleCycleDetails: (id) => api.get(`/api/disbursements/resale-cycles/${id}`), // v3.4.376
  delete: (id) => api.delete(`/api/disbursements/${id}`),
  archive: (id) => api.put(`/api/disbursements/${id}/archive`),
  unarchive: (id) => api.put(`/api/disbursements/${id}/unarchive`),
};

// ══════════════════════════════════════════════════════════════
// Client Groups API - تجميع العملاء
// ══════════════════════════════════════════════════════════════
export const clientGroups = {
  list:          ()           => api.get("/api/client-groups"),
  create:        (data)       => api.post("/api/client-groups", data),
  update:        (id, data)   => api.put(`/api/client-groups/${id}`, data),
  delete:        (id)         => api.delete(`/api/client-groups/${id}`),
  getMembers:    (id)         => api.get(`/api/client-groups/${id}/members`),
  addMembers:    (id, ids)    => api.post(`/api/client-groups/${id}/members`, { clientIds: ids }),
  removeMember:  (id, cid)    => api.delete(`/api/client-groups/${id}/members/${cid}`),
  getClientGroups: (cid)      => api.get(`/api/client-groups/client/${cid}`),
  // v3.3.593 — link/refresh all clients of the group's project into the group
  syncProject:   (id, projectId) => api.post(`/api/client-groups/${id}/sync-project`, projectId ? { projectId } : {}),
};

// v3.3.718 — سجل زوار المكتب
export const officeVisitors = {
  list:         (params)      => api.get("/api/office-visitors", { params }),
  create:       (data)        => api.post("/api/office-visitors", data),
  update:       (id, data)    => api.put(`/api/office-visitors/${id}`, data),
  delete:       (id)          => api.delete(`/api/office-visitors/${id}`),
  // v3.3.920 — مرفقات الزيارة
  uploadFiles:  (id, files)   => { const fd = new FormData(); for (const f of files) fd.append("files", f); return api.post(`/api/office-visitors/${id}/files`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 300000 }); },
  fileUrl:      (id, fid, dl) => `${API_BASE}/api/office-visitors/${id}/files/${fid}${dl ? "?dl=1" : ""}`,
  deleteFile:   (id, fid)     => api.delete(`/api/office-visitors/${id}/files/${fid}`),
  getTypes:     ()            => api.get("/api/office-visitors/types"),
  createType:   (name)        => api.post("/api/office-visitors/types", { name }),
  updateType:   (id, name)    => api.put(`/api/office-visitors/types/${id}`, { name }),
  deleteType:   (id)          => api.delete(`/api/office-visitors/types/${id}`),
  createOption: (typeId, label) => api.post(`/api/office-visitors/types/${typeId}/options`, { label }),
  updateOption: (id, label)   => api.put(`/api/office-visitors/options/${id}`, { label }),
  deleteOption: (id)          => api.delete(`/api/office-visitors/options/${id}`),
};

export const marketerGroups = {
  list:          ()           => api.get("/api/marketer-groups"),
  create:        (data)       => api.post("/api/marketer-groups", data),
  update:        (id, data)   => api.put(`/api/marketer-groups/${id}`, data),
  delete:        (id)         => api.delete(`/api/marketer-groups/${id}`),
  getMembers:    (id)         => api.get(`/api/marketer-groups/${id}/members`),
  addMembers:    (id, ids)    => api.post(`/api/marketer-groups/${id}/members`, { marketerIds: ids }),
  removeMember:  (id, mid)    => api.delete(`/api/marketer-groups/${id}/members/${mid}`),
  getMarketerGroups: (mid)    => api.get(`/api/marketer-groups/marketer/${mid}`),
};

// ── Prospect Groups (v3.3.274) ──
export const prospectGroups = {
  list:             ()         => api.get("/api/prospect-groups"),
  create:           (data)     => api.post("/api/prospect-groups", data),
  update:           (id, data) => api.put(`/api/prospect-groups/${id}`, data),
  delete:           (id)       => api.delete(`/api/prospect-groups/${id}`),
  resync:           (id)       => api.post(`/api/prospect-groups/${id}/resync`),
  getMembers:       (id)       => api.get(`/api/prospect-groups/${id}/members`),
  addMembers:       (id, ids)  => api.post(`/api/prospect-groups/${id}/members`, { prospectIds: ids }),
  removeMember:     (id, pid)  => api.delete(`/api/prospect-groups/${id}/members/${pid}`),
  getWaGroupNames:  ()         => api.get("/api/prospect-groups/wa-group-names"),
};

// ══════════════════════════════════════════════════════════════
// v3.3.683 — Improvement Tickets API - تكتات التحسينات
// ══════════════════════════════════════════════════════════════
export const tickets = {
  list:    ()          => api.get("/api/tickets"),
  create:  (formData)  => api.post("/api/tickets", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 300000 }),
  process: (id, data)  => api.patch(`/api/tickets/${id}`, data),
  remove:  (id)        => api.delete(`/api/tickets/${id}`),
};

// ══════════════════════════════════════════════════════════════
// v3.3.679 — Client Prospects API - العملاء المحتملون
// ══════════════════════════════════════════════════════════════
export const clientProspects = {
  // v3.4.236 — حجوزات دليلك + داشبورد المبيعات
  dalilakReservations: (params = {}) => api.get("/api/client-prospects/dalilak-reservations", { params }),
  createDalilakReservation: (d) => api.post("/api/client-prospects/dalilak-reservations", d),
  salesDashboard: (days, months, exclude) => api.get("/api/client-prospects/sales-dashboard", { params: { days, months, ...(exclude && exclude.length ? { exclude: exclude.join(",") } : {}) } }), // v3.4.246 — v3.4.283 exclude
  list:         ()          => api.get("/api/client-prospects"),
  create:       (data)      => api.post("/api/client-prospects", data),
  update:       (id, data)  => api.put(`/api/client-prospects/${id}`, data),
  remove:       (id)        => api.delete(`/api/client-prospects/${id}`),
  groups:       ()          => api.get("/api/client-prospects/groups"),
  createGroup:  (data)      => api.post("/api/client-prospects/groups", data),
  updateGroup:  (id, data)  => api.put(`/api/client-prospects/groups/${id}`, data),
  deleteGroup:  (id)        => api.delete(`/api/client-prospects/groups/${id}`),
  addMembers:   (id, ids)   => api.post(`/api/client-prospects/groups/${id}/members`, { prospectIds: ids }),
  removeMember: (id, pid)   => api.delete(`/api/client-prospects/groups/${id}/members/${pid}`),
  // v3.3.812 — تخصيص عملاء لمسوّق بوابة
  assign:       (ids, portal_user_id) => api.post("/api/client-prospects/assign", { ids, portal_user_id }),
  // v3.3.817 — ترحيل من وارد المناديب للقائمة العامة (أو إرجاع)
  promote:      (ids, promote = true) => api.post("/api/client-prospects/promote", { ids, promote }),
  // v3.3.815 — تصدير/استيراد Excel (أدمن)
  exportXlsx:   ()           => api.get("/api/client-prospects/export", { responseType: "blob" }),
  importXlsx:   (file, mode) => { const fd = new FormData(); fd.append("file", file); fd.append("mode", mode || "skip"); return api.post("/api/client-prospects/import", fd, { headers: { "Content-Type": "multipart/form-data" } }); },
  // v3.3.802 — ملاحظات الشركة التراكمية
  listNotes:    (id)         => api.get(`/api/client-prospects/${id}/notes`),
  addNote:      (id, text)   => api.post(`/api/client-prospects/${id}/notes`, { note_text: text }),
  deleteNote:   (id, noteId) => api.delete(`/api/client-prospects/${id}/notes/${noteId}`),
};

// ══════════════════════════════════════════════════════════════
// v3.3.824 — عروض الأراضي (نظام التسويق)
// ══════════════════════════════════════════════════════════════
// v3.4.420 — الإدارة القانونية
export const legal = {
  overview:   ()            => api.get("/api/legal/overview"),
  projects:   ()            => api.get("/api/legal/projects"),
  list:       (type)        => api.get(`/api/legal/${type}`),
  get:        (type, id)    => api.get(`/api/legal/${type}/${id}`),
  create:     (type, d)     => api.post(`/api/legal/${type}`, d),
  update:     (type, id, d) => api.put(`/api/legal/${type}/${id}`, d),
  remove:     (type, id)    => api.delete(`/api/legal/${type}/${id}`),
  uploadFile: (type, id, fd) => api.post(`/api/legal/${type}/${id}/files`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 600000 }),
  removeFile: (fileId)      => api.delete(`/api/legal/files/${fileId}`),
  fileUrl:    (fileId)      => `/api/legal/files/${fileId}`,
  addCaseEvent:    (id, d)     => api.post(`/api/legal/cases/${id}/events`, d),
  removeCaseEvent: (id, eid)   => api.delete(`/api/legal/cases/${id}/events/${eid}`),
};
// v3.4.399 — إعلانات عقار
export const aqarListings = {
  list:       ()        => api.get("/api/aqar-listings"),
  import:     (d)       => api.post("/api/aqar-listings/import", d, { timeout: 180000 }),
  refresh:    (id)      => api.post(`/api/aqar-listings/${id}/refresh`, {}, { timeout: 60000 }),
  refreshAll: ()        => api.post("/api/aqar-listings/refresh-all", {}, { timeout: 600000 }),
  events:     (id)      => api.get(`/api/aqar-listings/${id}/events`),
  update:     (id, d)   => api.patch(`/api/aqar-listings/${id}`, d),
  remove:     (id)      => api.delete(`/api/aqar-listings/${id}`),
  removePendingLink: (id) => api.delete(`/api/aqar-listings/pending-links/${id}`), // v3.4.406
  createAqarAccount: (d)     => api.post("/api/aqar-listings/accounts", d), // v3.4.411
  updateAqarAccount: (id, d) => api.patch(`/api/aqar-listings/accounts/${id}`, d),
  removeAqarAccount: (id)    => api.delete(`/api/aqar-listings/accounts/${id}`),
};
export const landOffers = {
  parseOffer: (text)      => api.post("/api/land-offers/parse-offer", { text }), // v3.3.952 — اللصق الذكي
  parseConfig:()          => api.get("/api/land-offers/parse-config"),           // v3.3.953 — إعداد مفتاح الذكاء
  saveParseConfig: (d)    => api.put("/api/land-offers/parse-config", d),
  list:       ()          => api.get("/api/land-offers"),
  create:     (data)      => api.post("/api/land-offers", data),
  update:     (id, data)  => api.put(`/api/land-offers/${id}`, data),
  setStatus:  (id, status)=> api.patch(`/api/land-offers/${id}/status`, { status }),
  remove:     (id)        => api.delete(`/api/land-offers/${id}`),
  mapConfig:  ()          => api.get("/api/land-offers/map-config"),
  setMapbox:  (token)     => api.put("/api/land-offers/map-config", { mapbox_token: token }),
  // v3.3.831 — الأحياء: ملف ثابت من الواجهة أولًا (/geo/… — بلا مصادقة ولا خدمة خارجية)، ثم الـAPI احتياطًا
  districts:  async (city = "jeddah", refresh) => {
    if (!refresh) {
      try { const r = await fetch(`/geo/districts_${city}.json`, { cache: "force-cache" }); if (r.ok) return { data: await r.json() }; } catch {}
    }
    return api.get(`/api/land-offers/districts/${city}`, { params: refresh ? { refresh: 1 } : {} });
  },
};
// v3.3.828 — عروض المشاريع (نظام التسويق)
export const projectOffers = {
  list:       ()          => api.get("/api/project-offers"),
  create:     (data)      => api.post("/api/project-offers", data),
  update:     (id, data)  => api.put(`/api/project-offers/${id}`, data),
  setStatus:  (id, status)=> api.patch(`/api/project-offers/${id}/status`, { status }),
  remove:     (id)        => api.delete(`/api/project-offers/${id}`),
  uploadFiles:(id, kind, files, url) => { const fd = new FormData(); fd.append("kind", kind); if (url) fd.append("url", url); (files || []).forEach(f => fd.append("files", f)); return api.post(`/api/project-offers/${id}/files`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 600000 }); }, // v3.4.045 — مهلة 10 دقائق للملفات الكبيرة (حتى 95MB)
  removeFile: (id, fid)   => api.delete(`/api/project-offers/${id}/files/${fid}`),
  fileUrl:    (id, fid, download) => `/api/project-offers/${id}/files/${fid}${download ? "?download=1" : ""}`,
  // v3.3.962 — إضافة مشروع بذكاء: نص و/أو PDF → Claude يستخرج كل الحقول والنماذج
  parse:      (text, pdf) => { const fd = new FormData(); if (text) fd.append("text", text); if (pdf) fd.append("pdf", pdf); return api.post("/api/project-offers/parse", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 600000 }); }, // v3.4.054 — 10 دقائق: الملفات الكبيرة تحتاج استخراج نص/ضغط قبل التحليل
};

// ══════════════════════════════════════════════════════════════
// v3.3.849 — إدارة المشاريع الإنشائية (Construction)
// ══════════════════════════════════════════════════════════════
export const construction = {
  projects:        ()          => api.get("/api/construction/projects"),
  createProject:   (data)      => api.post("/api/construction/projects", data),
  updateProject:   (id, data)  => api.put(`/api/construction/projects/${id}`, data),
  deleteProject:   (id)        => api.delete(`/api/construction/projects/${id}`),
  addSection:      (id, name)  => api.post(`/api/construction/projects/${id}/sections`, { name }),
  laborers:        ()          => api.get("/api/construction/laborers"),
  createLaborer:   (data)      => api.post("/api/construction/laborers", data),
  updateLaborer:   (id, data)  => api.put(`/api/construction/laborers/${id}`, data),
  deleteLaborer:   (id)        => api.delete(`/api/construction/laborers/${id}`),
  rateHistory:     (id)        => api.get(`/api/construction/laborers/${id}/rate-history`),
  laborerProfile:  (id)        => api.get(`/api/construction/laborers/${id}/profile`), // v3.3.853
  contractors:     ()          => api.get("/api/construction/contractors"),
  createContractor:(data)      => api.post("/api/construction/contractors", data),
  updateContractor:(id, data)  => api.put(`/api/construction/contractors/${id}`, data),
  deleteContractor:(id)        => api.delete(`/api/construction/contractors/${id}`),
  suppliers:       ()          => api.get("/api/construction/suppliers"),
  createSupplier:  (data)      => api.post("/api/construction/suppliers", data),
  updateSupplier:  (id, data)  => api.put(`/api/construction/suppliers/${id}`, data),
  deleteSupplier:  (id)        => api.delete(`/api/construction/suppliers/${id}`),
  classifications: (projectId) => api.get("/api/construction/classifications", { params: { project_id: projectId } }),
  contractsOverview: () => api.get("/api/construction/contracts-overview"), // v3.4.621 — الصفحة الرئيسية لعقود مقاولي الباطن
  // v3.4.627 — عقود «مقاول الشركة الرئيسي (يوميات)»
  dailyCosting: (id) => api.get(`/api/construction/contracts/${id}/daily-costing`),
  dailySection: (id, section_id) => api.post(`/api/construction/contracts/${id}/daily-section`, { section_id }),
  dailyMap: (id, d) => api.post(`/api/construction/contracts/${id}/daily-map`, d),
  dailyProgress: (id, d) => api.post(`/api/construction/contracts/${id}/daily-progress`, d),
  dailySync: (id) => api.post(`/api/construction/contracts/${id}/daily-sync`),
  daftraCostCenters: (q) => api.get("/api/construction/daftra-cost-centers", { params: { q } }),
  contractMaterials: (id) => api.get(`/api/construction/contracts/${id}/materials`),
  saveContractMaterials: (id, ids) => api.post(`/api/construction/contracts/${id}/materials`, { cost_center_ids: ids }),
  addClassification:(data)     => api.post("/api/construction/classifications", data),
  deleteClassification:(id)    => api.delete(`/api/construction/classifications/${id}`),
  renameClassification:(id, value) => api.put(`/api/construction/classifications/${id}`, { value }), // v3.3.863
  projectStructure: (pid) => api.get(`/api/construction/project-structure/${pid}`), // v3.4.659 — هياكل المشاريع
  reorderClassifications: (ids) => api.post("/api/construction/classifications/reorder", { ids }),
  projectRows: (pid) => api.get(`/api/construction/project-rows/${pid}`), // v3.4.660 — هيكل المشروع (صفوف المباني)
  addProjectRow: (pid, d) => api.post(`/api/construction/project-rows/${pid}`, d),
  renameProjectRow: (id, location) => api.put(`/api/construction/project-rows/${id}`, { location }),
  deleteProjectRow: (id) => api.delete(`/api/construction/project-rows/${id}`),
  reorderProjectRows: (pid, ids) => api.post(`/api/construction/project-rows/${pid}/reorder`, { ids }),
  mergeProjectRows: (pid, data) => api.post(`/api/construction/project-rows/${pid}/merge`, data), // v3.4.667
  mapStage: (id, data) => api.put(`/api/construction/classifications/${id}/map`, data), // v3.4.686
  autoMapStages: (pid, data) => api.post(`/api/construction/project-structure/${pid}/auto-map-stages`, data || {}), // v3.4.686
  bulkDeleteProjectRows: (pid, ids) => api.post(`/api/construction/project-rows/${pid}/bulk-delete`, { ids }), // v3.4.666
  buildProjectTree: (pid, data) => api.post(`/api/construction/project-rows/${pid}/build-tree`, data), // v3.4.665
  sortProjectRowsBottomUp: (pid) => api.post(`/api/construction/project-rows/${pid}/sort-bottom-up`), // v3.4.664
  generateProjectRows: (pid, data) => api.post(`/api/construction/project-rows/${pid}/generate`, data), // v3.4.664
  setItemProjectRow: (itemId, rowId) => api.put(`/api/construction/contract-items/${itemId}/project-row`, { project_row_id: rowId }), // v3.4.664
  linkContractRows: (cid, data) => api.post(`/api/construction/contracts/${cid}/link-project-rows`, data || {}), // v3.4.664
  sortProjectRowsLikeContracts: (pid) => api.post(`/api/construction/project-rows/${pid}/sort-like-contracts`), // v3.4.662
  importProjectRows: (pid, contract_id) => api.post(`/api/construction/project-rows/${pid}/import`, { contract_id: contract_id || null }),
  attendance:      (params)    => api.get("/api/construction/attendance", { params }),
  attendanceBulk:  (data)      => api.post("/api/construction/attendance/bulk", data),
  updateAttendance:(id, data)  => api.put(`/api/construction/attendance/${id}`, data),
  deleteAttendance:(id)        => api.delete(`/api/construction/attendance/${id}`),
  contractorServices:(projectId)=> api.get("/api/construction/contractor-services", { params: { project_id: projectId } }),
  createService:   (data)      => api.post("/api/construction/contractor-services", data),
  updateService:   (id, data)  => api.put(`/api/construction/contractor-services/${id}`, data),
  deleteService:   (id)        => api.delete(`/api/construction/contractor-services/${id}`),
  materials:       (projectId, category) => api.get("/api/construction/materials", { params: { project_id: projectId, category } }),
  createMaterial:  (data)      => api.post("/api/construction/materials", data),
  updateMaterial:  (id, data)  => api.put(`/api/construction/materials/${id}`, data),
  deleteMaterial:  (id)        => api.delete(`/api/construction/materials/${id}`),
  weeklySummary:   (projectId, sectionId) => api.get(`/api/construction/projects/${projectId}/weekly-summary`, { params: { section_id: sectionId } }),
  weeklyOrdersSummary: () => api.get("/api/construction/weekly-orders-summary"), // v3.4.001 — كل المشاريع: أسبوع ← مشروع ← بند ← فئة
  weeklyReport:    (projectId, sectionId, weekStart) => api.get(`/api/construction/projects/${projectId}/weekly-report`, { params: { section_id: sectionId, week_start: weekStart } }), // v3.3.869
  // v3.3.881 — دفعات المقاولين
  contracts:       (projectId) => api.get("/api/construction/contracts", { params: { project_id: projectId } }),
  createContract:  (data)      => api.post("/api/construction/contracts", data),
  contractDetail:  (id)        => api.get(`/api/construction/contracts/${id}`),
  subcontractors:   ()          => api.get("/api/construction/subcontractors"), // v3.4.409
  createSubcontractor: (d)      => api.post("/api/construction/subcontractors", d),
  updateSubcontractor: (id, d)  => api.put(`/api/construction/subcontractors/${id}`, d),
  removeSubcontractor: (id)     => api.delete(`/api/construction/subcontractors/${id}`),
  subcontractorOverview: (id)        => api.get(`/api/construction/subcontractors/${id}/overview`), // v3.4.412
  saveSubcontractorRate: (id, d)     => api.post(`/api/construction/subcontractors/${id}/rates`, d),
  removeSubcontractorRate: (id, rid) => api.delete(`/api/construction/subcontractors/${id}/rates/${rid}`),
  setContractSubcontractor: (id, subcontractor_id) => api.patch(`/api/construction/contracts/${id}/subcontractor`, { subcontractor_id }),
  // v3.4.734 — إنشاء عقود المقاولين من قوالب (باطن / رئيسي)
  ccMeta: () => api.get("/api/contractor-contracts/meta"),
  ccContracts: (kind) => api.get("/api/contractor-contracts/contracts", { params: { kind } }),
  ccPreview: (body) => api.post("/api/contractor-contracts/preview", body),
  ccGenerate: (kind, contract_id) => api.post("/api/contractor-contracts/generate", { kind, contract_id }),
  ccDocuments: (params) => api.get("/api/contractor-contracts/documents", { params }),
  ccContractSections: (id, kind) => api.get(`/api/contractor-contracts/contract-sections/${id}`, { params: { kind } }), // v3.4.751 — التفاصيل الفنية لعقد
  ccSaveContractSections: (id, body) => api.put(`/api/contractor-contracts/contract-sections/${id}`, body),
  ccResetContractSections: (id) => api.delete(`/api/contractor-contracts/contract-sections/${id}`),
  ccDeleteDocument: (id) => api.delete(`/api/contractor-contracts/${id}`),
  ccTemplates: (kind) => api.get("/api/contractor-contracts/templates", { params: { kind } }),
  ccSaveTemplate: (kind, category, body) => api.put(`/api/contractor-contracts/templates/${kind}/${encodeURIComponent(category)}`, body),
  ccResetTemplate: (kind, category) => api.delete(`/api/contractor-contracts/templates/${kind}/${encodeURIComponent(category)}`),
  ccSaveParties: (body) => api.put("/api/contractor-contracts/parties", body),
  ccProjectInfo: (id, body) => api.put(`/api/contractor-contracts/project-info/${id}`, body),
  uploadSignedContract: (id, fd) => api.post(`/api/construction/contracts/${id}/signed-contract`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 300000 }), // v3.4.400
  removeSignedContract: (id)     => api.delete(`/api/construction/contracts/${id}/signed-contract`),
  updateContract:  (id, data)  => api.put(`/api/construction/contracts/${id}`, data),
  deleteContract:  (id)        => api.delete(`/api/construction/contracts/${id}`),
  addContractStage:(id, data)  => api.post(`/api/construction/contracts/${id}/stages`, data),
  updateContractStage:(id, data)=> api.put(`/api/construction/contract-stages/${id}`, data),
  deleteContractStage:(id)     => api.delete(`/api/construction/contract-stages/${id}`),
  reorderContractStages:(id, ids) => api.post(`/api/construction/contracts/${id}/stages/reorder`, { ids }), // v3.4.441
  addContractItem: (id, data)  => api.post(`/api/construction/contracts/${id}/items`, data),
  updateContractItem:(id, data)=> api.put(`/api/construction/contract-items/${id}`, data),
  renameContractBuilding: (id, data) => api.post(`/api/construction/contracts/${id}/rename-building`, data), // v3.4.021
  deleteContractItem:(id)      => api.delete(`/api/construction/contract-items/${id}`),
  setContractProgress:(data)   => api.post("/api/construction/contract-progress", data),
  setContractNewPct:(data)     => api.post("/api/construction/contract-progress/new", data), // v3.3.889 — مسودة المستخلص
  sortItemsLikeStructure: (cid) => api.post(`/api/construction/contracts/${cid}/sort-like-structure`), // v3.4.681
  addItemsFromStructure: (cid, rowIds) => api.post(`/api/construction/contracts/${cid}/items-from-structure`, { row_ids: rowIds }), // v3.4.678
  applyReceiptRequest: (cid, requestId) => api.post(`/api/construction/contracts/${cid}/apply-receipt-request`, { request_id: requestId }), // v3.4.673
  addContractBoq:(id, data)    => api.post(`/api/construction/contracts/${id}/boq`, data), // v3.3.901
  updateContractBoq:(id, data) => api.put(`/api/construction/contract-boq/${id}`, data),
  deleteContractBoq:(id)       => api.delete(`/api/construction/contract-boq/${id}`),
  recalcContract:(id, data)    => api.post(`/api/construction/contracts/${id}/recalc`, data || {}),
  approveContractClaim:(id)    => api.post(`/api/construction/contracts/${id}/approve-claim`),
  clearContractClaim:(id)      => api.post(`/api/construction/contracts/${id}/clear-claim`),
  // v3.3.912 — أوامر صرف مستحقات المقاولين
  contractClaims:  (params)    => api.get("/api/construction/contract-claims", { params }),
  lockContract:    (id)        => api.post(`/api/construction/contracts/${id}/lock`),   // v3.3.916
  unlockContract:  (id)        => api.post(`/api/construction/contracts/${id}/unlock`),
  // v3.3.913 — تصدير/استيراد كميات كل عقود المشروع
  // v3.4.015 \u2014 contractId \u0627\u062E\u062A\u064A\u0627\u0631\u064A: \u062A\u0635\u062F\u064A\u0631/\u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0643\u0645\u064A\u0627\u062A \u0639\u0642\u062F \u0648\u0627\u062D\u062F \u0645\u0646 \u0634\u0627\u0634\u0629 \u0647\u064A\u0643\u0644 \u0627\u0644\u0639\u0642\u062F
  exportContractQuantities: (projectId, projectName, contractId) => downloadBlob(api.get(`/api/construction/projects/${projectId}/contracts-quantities.xlsx`, { responseType: "blob", params: contractId ? { contract_id: contractId } : {} }), `contracts_quantities_${(projectName || projectId).toString().replace(/[^a-zA-Z0-9\u0600-\u06FF\s_-]/g, "").trim().replace(/\s+/g, "_")}.xlsx`),
  importContractQuantities: (projectId, file, contractId) => { const fd = new FormData(); fd.append("file", file); if (contractId) fd.append("contract_id", contractId); return api.post(`/api/construction/projects/${projectId}/contracts-quantities/import`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 600000 }); },
  // v3.3.987 — مرجع الخرائط التنفيذية
  drawings:        (projectId) => api.get("/api/construction/drawings", { params: { project_id: projectId } }),
  uploadDrawing:   (fd)        => api.post("/api/construction/drawings", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 600000 }),
  deleteDrawing:   (id)        => api.delete(`/api/construction/drawings/${id}`),
  addDrawingCategory:    (d)      => api.post("/api/construction/drawing-categories", d), // v3.4.199
  removeDrawingCategory: (params) => api.delete("/api/construction/drawing-categories", { params }),
  // v3.4.220 — المهندس المسؤول لكل مشروع + تأكيد الاستلام والمراجعة لكل خريطة
  engineers:           ()            => api.get("/api/construction/engineers"),
  setEngineerProjects: (userId, d)   => api.put(`/api/construction/engineers/${userId}`, d),
  engineerSummary:     ()            => api.get("/api/construction/engineer-summary"),
  receiveDrawing:      (id)          => api.post(`/api/construction/drawings/${id}/receive`),
  reviewDrawing:       (id, d)       => api.post(`/api/construction/drawings/${id}/review`, d),
  // v3.3.971 — طلبات رفع مستخلص استلام
  receiptRequests: (params)    => api.get("/api/construction/receipt-requests", { params }),
  createReceiptRequest:(data)  => api.post("/api/construction/receipt-requests", data),
  executeReceiptRequest:(id)   => api.post(`/api/construction/receipt-requests/${id}/execute`),
  sendReceiptRequestWa: (id)   => api.post(`/api/construction/receipt-requests/${id}/send-wa`), // v3.4.721 — إعادة إرسال PDF للمقاول عبر واتساب
  deleteReceiptRequest:(id)    => api.delete(`/api/construction/receipt-requests/${id}`),
  approveClaim:    (id)        => api.post(`/api/construction/contract-claims/${id}/approve`),
  rejectClaim:     (id, reason)=> api.post(`/api/construction/contract-claims/${id}/reject`, { reason }),
  payClaim:        (id)        => api.post(`/api/construction/contract-claims/${id}/pay`),
  deleteClaim:     (id)        => api.delete(`/api/construction/contract-claims/${id}`),
  addContractPayment:(id, data)=> api.post(`/api/construction/contracts/${id}/payments`, data),
  deleteContractPayment:(id)   => api.delete(`/api/construction/contract-payments/${id}`),
  // v3.3.868 — أوامر صرف اليوميات الأسبوعية
  paymentOrders:   (params)    => api.get("/api/construction/payment-orders", { params }),
  createPaymentOrder:(data)    => api.post("/api/construction/payment-orders", data),
  approvePaymentOrder:(id)     => api.post(`/api/construction/payment-orders/${id}/approve`),
  payPaymentOrder: (id)        => api.post(`/api/construction/payment-orders/${id}/pay`),
  deletePaymentOrder:(id)      => api.delete(`/api/construction/payment-orders/${id}`),
  overview:        (projectId) => api.get(`/api/construction/projects/${projectId}/overview`),
  importXlsx:      (projectId, file) => { const fd = new FormData(); fd.append("file", file); return api.post(`/api/construction/projects/${projectId}/import-xlsx`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 600000 }); },
};

// ══════════════════════════════════════════════════════════════
// Prospects API - المحتملين
// ══════════════════════════════════════════════════════════════
export const prospects = {
  list:        (params)     => api.get("/api/prospects", { params }),
  getSources:  ()           => api.get("/api/prospects/sources"),
  getStats:    ()           => api.get("/api/prospects/stats"),
  analysis:    ()           => api.get("/api/prospects/analysis"), // v3.4.278
  classes:      ()          => api.get("/api/prospects/classes"), // v3.4.310
  setFinalClass: (id, cls)  => api.put(`/api/prospects/${id}/final-class`, { cls }), // v3.4.324
  createClass:  (d)         => api.post("/api/prospects/classes", d),
  updateClass:  (id, d)     => api.put(`/api/prospects/classes/${id}`, d),
  deleteClass:  (id)        => api.delete(`/api/prospects/classes/${id}`),
  add:         (data)       => api.post("/api/prospects", data),
  bulkAdd:     (data)       => api.post("/api/prospects/bulk", data),
  bulkFromGroup: (data)    => api.post("/api/prospects/bulk-from-group", data),
  update:      (id, data)   => api.put(`/api/prospects/${id}`, data),
  delete:      (id)         => api.delete(`/api/prospects/${id}`),
  bulkDelete:  (ids)        => api.post("/api/prospects/bulk-delete", { ids }),
  convert:     (id, to)     => api.post(`/api/prospects/${id}/convert`, { convert_to: to }),
  // v3.3.614 — ملاحظات تراكمية
  getNotes:    (id)         => api.get(`/api/prospects/${id}/notes`),
  addNote:     (id, text)   => api.post(`/api/prospects/${id}/notes`, { note_text: text }),
  deleteNote:  (id, noteId) => api.delete(`/api/prospects/${id}/notes/${noteId}`),
};

// ══════════════════════════════════════════════════════════════
// WhatsApp Business Cloud API - التواصل المؤسسي
// ══════════════════════════════════════════════════════════════
export const waBusiness = {
  // Config
  getConfigStatus:       ()           => api.get("/api/wa-business/config-status"),
  // Templates
  getTemplates:          ()           => api.get("/api/wa-business/templates"),
  syncTemplates:         ()           => api.get("/api/wa-business/templates/sync"),
  wabas:                 ()           => api.get("/api/wa-business/wabas"), // v3.4.098 — حسابات واتساب الأعمال وأرقامها
  createTemplate:        (data)       => api.post("/api/wa-business/templates", data),
  updateTemplate:        (id, data)   => api.put(`/api/wa-business/templates/${id}`, data),
  deleteTemplate:        (id)         => api.delete(`/api/wa-business/templates/${id}`),
  // Send
  send:                  (data)       => api.post("/api/wa-business/send", data),
  sendBulk:              (data)       => api.post("/api/wa-business/send-bulk", data),
  getBulkStatus:         (batchId)    => api.get(`/api/wa-business/bulk-status/${batchId}`),
  // Messages
  getMessages:           (params)     => api.get("/api/wa-business/messages", { params }),
  getConversation:       (phone)      => api.get(`/api/wa-business/messages/conversation/${encodeURIComponent(phone)}`),
  markRead:              (id)         => api.put(`/api/wa-business/messages/${id}/read`),
  // Dashboard
  getDashboard:          ()           => api.get("/api/wa-business/dashboard"),
  // Auto Notifications
  getAutoNotifications:  ()           => api.get("/api/wa-business/auto-notifications"),
  createAutoNotification: (data)      => api.post("/api/wa-business/auto-notifications", data),
  updateAutoNotification: (id, data)  => api.put(`/api/wa-business/auto-notifications/${id}`, data),
  deleteAutoNotification: (id)        => api.delete(`/api/wa-business/auto-notifications/${id}`),
  // Contacts
  getContactClients:     (params)     => api.get("/api/wa-business/contacts/clients", { params }),
  getContactMarketers:   (params)     => api.get("/api/wa-business/contacts/marketers", { params }),
  getContactProspects:   (params)     => api.get("/api/wa-business/contacts/prospects", { params }),
};

// ── App Settings ──
// v3.4.255 — فواتير الكلاود
// v3.4.425 — خريطة التخزين (مسح شجرة Google Drive + إحصاءات التخزين في قاعدة البيانات) — أدمن فقط
export const storageAudit = {
  status: () => api.get("/api/storage-audit/status"),
  scan: () => api.post("/api/storage-audit/scan"),
  tree: (id) => api.get(id ? `/api/storage-audit/tree/${id}` : "/api/storage-audit/tree"),
  dbRefs: () => api.get("/api/storage-audit/db-refs"),
  dbStats: () => api.get("/api/storage-audit/db-stats"),
  reorganize: (dry) => api.post("/api/storage-audit/reorganize", { dry: dry !== false }), // v3.4.426
  reorgStatus: () => api.get("/api/storage-audit/reorganize/status"),
  reorgRun: (id) => api.get(`/api/storage-audit/reorganize/${id}`),
};
export const cloudBilling = {
  getSettings: () => api.get("/api/cloud-billing/settings"),
  saveSettings: (data) => api.put("/api/cloud-billing/settings", data),
  digitalocean: (refresh) => api.get("/api/cloud-billing/digitalocean", { params: refresh ? { refresh: 1 } : {} }),
  anthropic: (months, refresh) => api.get("/api/cloud-billing/anthropic", { params: { months, ...(refresh ? { refresh: 1 } : {}) } }),
  // v3.4.267 — فواتير جوجل
  googleInvoices: (months) => api.get("/api/cloud-billing/google/invoices", { params: { months } }),
  addGoogleInvoice: (formData) => api.post("/api/cloud-billing/google/invoices", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  updateGoogleInvoice: (id, data) => api.put(`/api/cloud-billing/google/invoices/${id}`, data),
  deleteGoogleInvoice: (id) => api.delete(`/api/cloud-billing/google/invoices/${id}`),
  gmailSync: (months, wide) => api.post("/api/cloud-billing/google/gmail-sync", { months, wide: !!wide }),
  gmailPreview: (months) => api.get("/api/cloud-billing/google/gmail-preview", { params: { months }, timeout: 120000 }), // v3.4.706 — فحص الصندوق
  reparseGooglePdfs: (all) => api.post("/api/cloud-billing/google/invoices/reparse", { all: !!all }, { timeout: 180000 }), // v3.4.708
  importGoogleCsv: (fd, dry) => api.post("/api/cloud-billing/google/import-transactions" + (dry ? "?dry=1" : ""), fd, { headers: { "Content-Type": "multipart/form-data" } }), // v3.4.707
  gmailSyncStatus: () => api.get("/api/cloud-billing/google/gmail-sync/status"), // v3.4.705 — المزامنة في الخلفية
  googleUsers: (refresh) => api.get("/api/cloud-billing/google/users", { params: refresh ? { refresh: 1 } : {} }), // v3.4.705 — مستخدمو Workspace
  // v3.4.821 — إدارة Workspace من النظام: نطاقات، إنشاء مستخدم، إيقاف/استعادة، عناوين بديلة، مجموعات وأعضاؤها
  googleDomains: () => api.get("/api/cloud-billing/google/domains"),
  createGoogleUser: (d) => api.post("/api/cloud-billing/google/users", d),
  suspendGoogleUser: (email, suspended) => api.post(`/api/cloud-billing/google/users/${encodeURIComponent(email)}/suspend`, { suspended }),
  addGoogleAlias: (email, alias) => api.post(`/api/cloud-billing/google/users/${encodeURIComponent(email)}/aliases`, { alias }),
  removeGoogleAlias: (email, alias) => api.delete(`/api/cloud-billing/google/users/${encodeURIComponent(email)}/aliases/${encodeURIComponent(alias)}`),
  googleGroups: (refresh) => api.get("/api/cloud-billing/google/groups", { params: refresh ? { refresh: 1 } : {} }),
  createGoogleGroup: (d) => api.post("/api/cloud-billing/google/groups", d),
  addGoogleGroupMember: (group, email, role) => api.post(`/api/cloud-billing/google/groups/${encodeURIComponent(group)}/members`, { email, role }),
  removeGoogleGroupMember: (group, member) => api.delete(`/api/cloud-billing/google/groups/${encodeURIComponent(group)}/members/${encodeURIComponent(member)}`),
};

// v3.4.271 — إدارة جروب التحديثات (واتس)
export const waUpdatesGroup = {
  weeks: (week_start) => api.get("/api/wa-updates-group/weeks", { params: week_start ? { week_start } : {} }),
  addRow: (data) => api.post("/api/wa-updates-group/rows", data),
  updateRow: (id, data) => api.put(`/api/wa-updates-group/rows/${id}`, data),
  deleteRow: (id) => api.delete(`/api/wa-updates-group/rows/${id}`),
  strategy: () => api.get("/api/wa-updates-group/strategy"), // v3.4.273
  saveStrategy: (strategy) => api.put("/api/wa-updates-group/strategy", { strategy }),
  resetStrategy: () => api.delete("/api/wa-updates-group/strategy"),
  content: (project_id) => api.get("/api/wa-updates-group/content", { params: project_id != null ? { project_id } : {} }), // v3.4.275
  addContent: (formData) => api.post("/api/wa-updates-group/content", formData, { headers: { "Content-Type": "multipart/form-data" } }),
  updateContent: (id, data) => api.put(`/api/wa-updates-group/content/${id}`, data),
  deleteContent: (id) => api.delete(`/api/wa-updates-group/content/${id}`),
};

// v3.4.283 — إدارة السوشل ميديا
// v3.4.489 — المواقع الإلكترونية
export const websites = {
  list: () => api.get("/api/websites"),
  get: (key) => api.get(`/api/websites/${key}`),
  saveContent: (key, d) => api.put(`/api/websites/${key}/content`, d),
  saveSettings: (key, d) => api.put(`/api/websites/${key}/settings`, d),
  domainStatus: (key) => api.get(`/api/websites/${key}/domain-status`),
  uploadLogo: (key, fd) => api.post(`/api/websites/${key}/logo`, fd, { headers: { "Content-Type": "multipart/form-data" } }), // v3.4.494
  // v3.4.500 — الموقع الكامل
  getSite: (key) => api.get(`/api/websites/${key}/site`),
  saveSite: (key, site) => api.put(`/api/websites/${key}/site`, { site }),
  uploadPhoto: (key, slot, fd) => api.post(`/api/websites/${key}/photo/${slot}`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 }),
  deletePhoto: (key, slot) => api.delete(`/api/websites/${key}/photo/${slot}`),
  systemProjects: (key) => api.get(`/api/websites/${key}/system-projects`),
  systemImages: (key) => api.get(`/api/websites/${key}/system-images`), // v3.4.502
  publish: (key) => api.post(`/api/websites/${key}/publish`), // v3.4.503 — نشر نسخة على الموقع الرئيسي
  setMode: (key, mode) => api.post(`/api/websites/${key}/mode`, { mode }),
  fetchBlob: (url) => api.get(url, { responseType: "blob", timeout: 0 }),
};

export const socialMedia = {
  accounts: (company) => api.get("/api/social-media/accounts", { params: company ? { company } : {} }),
  addAccount: (d) => api.post("/api/social-media/accounts", d),
  updateAccount: (id, d) => api.put(`/api/social-media/accounts/${id}`, d),
  deleteAccount: (id) => api.delete(`/api/social-media/accounts/${id}`),
  campaignCompanies: (platform) => api.get("/api/social-media/campaign-companies", { params: platform ? { platform } : {} }),
  setCampaignCompany: (d) => api.put("/api/social-media/campaign-companies", d),
  adsAccounts: () => api.get("/api/social-media/ads-accounts"), // v3.4.285
  saveAdsAccount: (d) => api.put("/api/social-media/ads-accounts", d),
  migrateLegacyAds: (d) => api.post("/api/social-media/ads-accounts/migrate-legacy", d), // v3.4.545
  adsInsights: (platform, company, refresh, range) => api.get("/api/social-media/ads-insights", { params: { platform, company: company || "", ...(refresh ? { refresh: 1 } : {}), ...(range?.since ? { since: range.since, until: range.until } : {}) }, timeout: 45000 }), // v3.4.553 — نطاق زمني + مهلة
  crmCampaigns: (platform) => api.get("/api/social-media/crm-campaigns", { params: { platform } }), // v3.4.553 — وارد النظام حسب الحملة (بصلاحية السوشل)
  tiktokOauth: (d) => api.post("/api/social-media/ads-accounts/tiktok-oauth", d, { timeout: 30000 }), // v3.4.553 — توكن تيك توك لشركة
  // v3.4.554 — سجل الحملات اليومي + المزامنة + الحملات اليدوية
  trend: (params) => api.get("/api/social-media/trend", { params }),
  syncCampaigns: (days) => api.post("/api/social-media/sync", null, { params: { days: days || 7 }, timeout: 120000 }),
  syncStatus: () => api.get("/api/social-media/sync-status"),
  addCampaign: (d) => api.post("/api/social-media/campaigns", d),
  updateCampaign: (id, d) => api.put(`/api/social-media/campaigns/${id}`, d),
  deleteCampaign: (id) => api.delete(`/api/social-media/campaigns/${id}`),
  // v3.4.316 — ربط حسابات السوشل ميديا بالـAPI + البيانات الحيّة + النشر
  apiLinks: () => api.get("/api/social-media/api-links"),
  saveApiLink: (d) => api.put("/api/social-media/api-links", d),
  profile: (platform, company, refresh) => api.get("/api/social-media/profile", { params: { platform, company, ...(refresh ? { refresh: 1 } : {}) }, timeout: 45000 }),
  dms: (platform, company) => api.get("/api/social-media/dms", { params: { platform, company }, timeout: 45000 }), // v3.4.810 — الرسائل الخاصة
  publish: (d) => api.post("/api/social-media/publish", d, { timeout: 60000 }),
  notes: (company, platform) => api.get("/api/social-media/notes", { params: { company: company || "", platform } }), // v3.4.771
  saveNotes: (d) => api.put("/api/social-media/notes", d),
  adsBudget: (params) => api.get("/api/social-media/ads-budget", { params }), // v3.4.787
  saveAdsBudget: (d) => api.put("/api/social-media/ads-budget", d),
  addAdsPayment: (d) => api.post("/api/social-media/ads-payments", d),
  deleteAdsPayment: (id) => api.delete(`/api/social-media/ads-payments/${id}`),
  tiktokEvents: () => api.get("/api/social-media/tiktok-events"), // v3.4.772
  saveTiktokEvents: (d) => api.put("/api/social-media/tiktok-events", d),
  adPreview: (d) => api.post("/api/social-media/campaign-ad-preview", d, { timeout: 30000 }), // v3.4.779 — QR معاينة على الجوال
  campaignDetail: (p) => api.get("/api/social-media/campaign-detail", { params: p, timeout: 45000 }), // v3.4.777
  testTiktokEvents: (channel) => api.post("/api/social-media/tiktok-events/test", { channel: channel || "web" }, { timeout: 30000 }), // v3.4.774 channel crm
};

// v3.4.284 — REGA & SAKANI لكل مشروع
export const projectRega = {
  get: (projectId) => api.get(`/api/project-rega/${projectId}`),
  addGroup: (projectId, d) => api.post(`/api/project-rega/${projectId}/groups`, d),
  updateGroup: (id, d) => api.put(`/api/project-rega/groups/${id}`, d),
  deleteGroup: (id) => api.delete(`/api/project-rega/groups/${id}`),
  upload: (groupId, formData) => api.post(`/api/project-rega/groups/${groupId}/docs`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
  deleteDoc: (id) => api.delete(`/api/project-rega/docs/${id}`),
};

export const appSettings = {
  getWaChannels: () => api.get("/api/app-settings/wa-channels"),
  updateWaChannels: (data) => api.put("/api/app-settings/wa-channels", data),
};

// ── Financial Analysis ──
export const financialAnalysis = {
  getSales:         (params) => api.get("/api/financial-analysis/sales", { params }), // v3.4.538 — المبيعات
  getPayments:      (params) => api.get("/api/financial-analysis/payments", { params }),
  // v3.3.344 — Timeline للرسم البياني الزمني (كامل النطاق)
  getPaymentsTimeline: (params) => api.get("/api/financial-analysis/payments-timeline", { params }),
  // v3.3.348 — Collections Timeline (تحصيل + ديون جديدة + ديون متبقية تراكمي)
  getCollectionsTimeline: (params) => api.get("/api/financial-analysis/collections-timeline", { params }),
  // v3.4.056 — جدول السداد المتفق عليه مقابل المُحصّل فعليًا
  getRepaymentsTimeline: (params) => api.get("/api/financial-analysis/repayments-timeline", { params }),
  getCollections:   (params) => api.get("/api/financial-analysis/collections", { params }),
  getClientCollections: (clientId) => api.get(`/api/financial-analysis/client-collections/${clientId}`), // v3.4.801
  getReminderSettings:  ()  => api.get("/api/financial-analysis/reminder-settings"), // v3.4.691 — نص تذكير الدفعة القادمة
  saveReminderSettings: (s) => api.put("/api/financial-analysis/reminder-settings", s),
  extractContractDate: (unitId) => api.post(`/api/financial-analysis/collections/${unitId}/contract-date/extract`), // v3.4.216
  setExpectedThisMonth: (unitId, expected) => api.patch(`/api/financial-analysis/collections/${unitId}/expected-this-month`, { expected }), // v3.4.226
  setCompanyEmployee: (unitId, on) => api.patch(`/api/financial-analysis/collections/${unitId}/company-employee`, { on }), // v3.4.458
  setAgreedDate:    (unitId, agreed_expected_date) => api.patch("/api/financial-analysis/collections/" + unitId + "/agreed-date", { agreed_expected_date }), // v3.4.510 — التاريخ المتوقع حسب التفاهمات
  setContractDate:  (unitId, contract_signed_date) => api.patch(`/api/financial-analysis/collections/${unitId}/contract-date`, { contract_signed_date }), // v3.4.210
  setContractTerms: (unitId, d) => api.patch(`/api/financial-analysis/units/${unitId}/contract-terms`, d), // v3.4.571 — تاريخ التوقيع + الشرط الجزائي + مدة العقد
  getCommissions:   (params) => api.get("/api/financial-analysis/commissions", { params }),
  getAdminFees:     (params) => api.get("/api/financial-analysis/admin-fees", { params }),
  getCashFlow:      (params) => api.get("/api/financial-analysis/cash-flow", { params }),
  getCashFlowMonthly: (params) => api.get("/api/financial-analysis/cash-flow-monthly", { params }), // v3.4.470
  getCashFlowMonthDetail: (params) => api.get("/api/financial-analysis/cash-flow-monthly/detail", { params }), // v3.4.472
  getDashboard:     ()       => api.get("/api/financial-analysis/dashboard"), // v3.4.327
  getBenchmarking:  ()       => api.get("/api/financial-analysis/benchmarking"),
  getReports:       (params) => api.get("/api/financial-analysis/reports", { params }),
  getCompanyAssets: (params) => api.get("/api/financial-analysis/company-assets", { params }),
  // v3.3.387 — Cash Flow Statements (التدفقات النقدية)
  listStatements:    ()                 => api.get("/api/financial-analysis/cash-flow-statements"),
  getStatement:      (id)               => api.get(`/api/financial-analysis/cash-flow-statements/${id}`),
  createStatement:   (data)             => api.post("/api/financial-analysis/cash-flow-statements", data),
  updateStatement:   (id, data)         => api.patch(`/api/financial-analysis/cash-flow-statements/${id}`, data),
  deleteStatement:   (id)               => api.delete(`/api/financial-analysis/cash-flow-statements/${id}`),
  addItem:           (id, data)         => api.post(`/api/financial-analysis/cash-flow-statements/${id}/items`, data),
  updateItem:        (id, itemId, data) => api.patch(`/api/financial-analysis/cash-flow-statements/${id}/items/${itemId}`, data),
  deleteItem:        (id, itemId)       => api.delete(`/api/financial-analysis/cash-flow-statements/${id}/items/${itemId}`),
  reorderItems:      (id, itemIds)      => api.post(`/api/financial-analysis/cash-flow-statements/${id}/items/reorder`, { item_ids: itemIds }),
  // v3.3.389 — Turnover Point chart
  getTurnover:       (id, params)       => api.get(`/api/financial-analysis/cash-flow-statements/${id}/turnover`, { params }),
  // v3.3.450 — Linkable sukuk contracts for "Loans" items
  getLinkableContracts: ()               => api.get("/api/financial-analysis/sukuk-contracts-for-linking"),
  // v3.3.580 — Search Daftra journal accounts + cost centers for cash-flow item linking
  cfAccountSearch:      (q, limit = 20)  => api.get("/api/financial-analysis/cf-account-search", { params: { q, limit } }),
};

// ── Reservations Scheduler — تنسيق الحجوزات ──
export const reservationsScheduler = {
  list:          (params)              => api.get("/api/reservations-scheduler", { params }),
  updateClosing: (reservationId, data) => api.put(`/api/reservations-scheduler/${reservationId}`, data),
  updateExpectedAmount: (reservationId, amount) => api.patch(`/api/reservations-scheduler/${reservationId}/expected-amount`, { amount }), // v3.4.473
};

// ── CAPEX — المصاريف الرأسمالية (v3.3.391) ──
export const capex = {
  // Projects
  listProjects:    ()           => api.get("/api/capex/projects"),
  createProject:   (data)       => api.post("/api/capex/projects", data),
  updateProject:   (id, data)   => api.patch(`/api/capex/projects/${id}`, data),
  deleteProject:   (id)         => api.delete(`/api/capex/projects/${id}`),
  // Expenses
  listExpenses:    (projectId)            => api.get(`/api/capex/projects/${projectId}/expenses`),
  createExpense:   (projectId, data)      => api.post(`/api/capex/projects/${projectId}/expenses`, data),
  bulkExpenses:    (projectId, data)      => api.post(`/api/capex/projects/${projectId}/expenses/bulk`, data),
  updateExpense:   (expId, data)          => api.patch(`/api/capex/expenses/${expId}`, data),
  deleteExpense:   (expId)                => api.delete(`/api/capex/expenses/${expId}`),
  // Analysis
  analyze:         (projectId)            => api.get("/api/capex/analysis", { params: projectId ? { project_id: projectId } : {} }),
  analyzeMonth:    (month, projectId)     => api.get("/api/capex/analysis/month", { params: { month, ...(projectId ? { project_id: projectId } : {}) } }), // v3.4.692 — معاملات شهر واحد
  // v3.3.628 — ربط بشجرة التكاليف المحاسبية
  ccTree:          ()                     => api.get("/api/capex/cc-tree"),
  projectAccounting: (projectId, params = {}) => api.get(`/api/capex/projects/${projectId}/accounting`, { params }),
  ccTransactions:  (params = {})          => api.get("/api/capex/transactions", { params }),
  // v3.3.394 — Export / Import (v3.3.395 — switched to blob download for proper credentials + error handling)
  exportProject:   (projectId, projectName) => downloadBlob(api.get(`/api/capex/projects/${projectId}/export`, { responseType: "blob" }), `capex_${(projectName || "project_" + projectId).replace(/[^a-zA-Z0-9\u0600-\u06FF\s_-]/g, "").trim().replace(/\s+/g, "_")}.xlsx`),
  downloadTemplate: ()                     => downloadBlob(api.get(`/api/capex/template`, { responseType: "blob" }), "capex_template.xlsx"),
  importFile:      (file, projectId, mode) => {
    const fd = new FormData();
    fd.append("file", file);
    const params = {};
    if (projectId) params.project_id = projectId;
    if (mode) params.mode = mode;
    return api.post("/api/capex/import", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      params,
    });
  },
};

// v3.3.395 — Helper: download a blob response with proper filename
async function downloadBlob(promise, defaultFilename) {
  try {
    const response = await promise;
    const blob = new Blob([response.data], {
      type: response.headers["content-type"] || "application/octet-stream",
    });
    // Try to extract filename from Content-Disposition
    let filename = defaultFilename;
    const cd = response.headers["content-disposition"];
    if (cd) {
      // RFC 5987: filename*=UTF-8''<urlencoded>
      const m1 = cd.match(/filename\*=UTF-8''([^;]+)/i);
      if (m1) {
        try { filename = decodeURIComponent(m1[1]); } catch {}
      } else {
        const m2 = cd.match(/filename="([^"]+)"/i);
        if (m2) filename = m2[1];
      }
    }
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
    return response;
  } catch (e) {
    // If error response is a Blob (JSON), parse it
    if (e.response?.data instanceof Blob) {
      try {
        const text = await e.response.data.text();
        const json = JSON.parse(text);
        e.response.data = json;
      } catch {}
    }
    throw e;
  }
}

// ── Sukuk Financing — التمويل (v3.3.397) ──
export const sukuk = {
  // Offers
  listOffers:     ()           => api.get("/api/sukuk/offers"),
  getOffer:       (id)         => api.get(`/api/sukuk/offers/${id}`),
  createOffer:    (data)       => api.post("/api/sukuk/offers", data),
  updateOffer:    (id, data)   => api.patch(`/api/sukuk/offers/${id}`, data),
  deleteOffer:    (id)         => api.delete(`/api/sukuk/offers/${id}`),
  convertOffer:   (id, data)   => api.post(`/api/sukuk/offers/${id}/convert`, data),
  // v3.3.399 — Offer tranches (detailed schedule)
  addOfferTranche:    (offerId, data) => api.post(`/api/sukuk/offers/${offerId}/tranches`, data),
  updateOfferTranche: (id, data)      => api.patch(`/api/sukuk/offer-tranches/${id}`, data),
  deleteOfferTranche: (id)            => api.delete(`/api/sukuk/offer-tranches/${id}`),
  generateOfferSchedule: (offerId, data) => api.post(`/api/sukuk/offers/${offerId}/generate-schedule`, data),
  // v3.3.405 — Tranche payments (custom repayment schedule)
  getTrancheDetails:    (id)             => api.get(`/api/sukuk/offer-tranches/${id}`),
  addTranchePayment:    (trancheId, data) => api.post(`/api/sukuk/offer-tranches/${trancheId}/payments`, data),
  updateTranchePayment: (id, data)        => api.patch(`/api/sukuk/tranche-payments/${id}`, data),
  deleteTranchePayment: (id)              => api.delete(`/api/sukuk/tranche-payments/${id}`),
  generateDefaultPaymentSchedule: (trancheId, data) => api.post(`/api/sukuk/offer-tranches/${trancheId}/payments/generate-default`, data),

  // v3.3.408 — Documents (Drive integration)
  getOfferDocuments:    (offerId)        => api.get(`/api/sukuk/offers/${offerId}/documents`),
  uploadOfferDocument:  (offerId, formData) => api.post(`/api/sukuk/offers/${offerId}/documents`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
  getContractDocuments: (contractId)     => api.get(`/api/sukuk/contracts/${contractId}/documents`),
  uploadContractDocument:(contractId, formData) => api.post(`/api/sukuk/contracts/${contractId}/documents`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
  getSukukDocuments:    (sukukId)        => api.get(`/api/sukuk/sukuks/${sukukId}/documents`),
  uploadSukukDocument:  (sukukId, formData) => api.post(`/api/sukuk/sukuks/${sukukId}/documents`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
  deleteDocument:       (id)             => api.delete(`/api/sukuk/documents/${id}`),
  updateDocument:       (id, data)       => api.patch(`/api/sukuk/documents/${id}`, data),
  // Contracts
  listContracts:  ()           => api.get("/api/sukuk/contracts"),
  getContract:    (id)         => api.get(`/api/sukuk/contracts/${id}`),
  createContract: (data)       => api.post("/api/sukuk/contracts", data),
  updateContract: (id, data)   => api.patch(`/api/sukuk/contracts/${id}`, data),
  deleteContract: (id)         => api.delete(`/api/sukuk/contracts/${id}`),
  // Programs
  createProgram:  (cid, data)        => api.post(`/api/sukuk/contracts/${cid}/programs`, data),
  updateProgram:  (id, data)         => api.patch(`/api/sukuk/programs/${id}`, data),
  deleteProgram:  (id)               => api.delete(`/api/sukuk/programs/${id}`),
  generateTranches: (pid, data)      => api.post(`/api/sukuk/programs/${pid}/generate-tranches`, data),
  // Sukuks
  createSukuk:    (pid, data)        => api.post(`/api/sukuk/programs/${pid}/sukuks`, data),
  updateSukuk:    (id, data)         => api.patch(`/api/sukuk/sukuks/${id}`, data),
  deleteSukuk:    (id)               => api.delete(`/api/sukuk/sukuks/${id}`),
  activateSukuk:  (id, data)         => api.post(`/api/sukuk/sukuks/${id}/activate`, data),
  markRepaid:     (id, data)         => api.post(`/api/sukuk/sukuks/${id}/mark-repaid`, data),
  unmarkRepaid:   (id)               => api.post(`/api/sukuk/sukuks/${id}/unmark-repaid`),
  cancelSukuk:    (id)               => api.post(`/api/sukuk/sukuks/${id}/cancel`),
  // v3.3.425 — Deactivate (revert active sukuk back to pending)
  deactivateSukuk: (id)              => api.post(`/api/sukuk/sukuks/${id}/deactivate`),
  // v3.3.427 — Per-payment repayment tracking
  getSukukRepayments: (id)           => api.get(`/api/sukuk/sukuks/${id}/repayments`),
  markPaymentPaid: (paymentId, data) => api.post(`/api/sukuk/tranche-payments/${paymentId}/mark-paid`, data),
  unmarkPaymentPaid: (paymentId)     => api.post(`/api/sukuk/tranche-payments/${paymentId}/unmark-paid`),
  // v3.3.429 — Analytics
  getPaymentSchedule: (params = {}) => api.get(`/api/sukuk/sukuks/payment-schedule`, { params }),
  getAnalytics: (params = {})       => api.get(`/api/sukuk/sukuks/analytics`, { params }),
  // v3.3.420 — Active sukuks (مديونيات قائمة)
  listActiveSukuks: (params = {})    => api.get(`/api/sukuk/sukuks/active`, { params }),
  // Analysis
  analyze:        (cid)              => api.get(`/api/sukuk/contracts/${cid}/analysis`),
  // v3.3.398 — Export / Import
  exportOffer:        (id)           => downloadBlob(api.get(`/api/sukuk/offers/${id}/export`, { responseType: "blob" }), `sukuk_offer_${id}.xlsx`),
  offerTemplate:      ()             => downloadBlob(api.get(`/api/sukuk/offers/template`, { responseType: "blob" }), `sukuk_offer_template.xlsx`),
  importOffer:        (file)         => {
    const fd = new FormData(); fd.append("file", file);
    return api.post(`/api/sukuk/offers/import`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  },
  // v3.3.411 — Re-import: replace tranches/payments of an existing offer
  reimportOffer:      (file, offerId) => {
    const fd = new FormData(); fd.append("file", file);
    return api.post(`/api/sukuk/offers/import`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      params: { replace_offer_id: offerId }
    });
  },
  exportContract:     (id)           => downloadBlob(api.get(`/api/sukuk/contracts/${id}/export`, { responseType: "blob" }), `sukuk_contract_${id}.xlsx`),
  contractTemplate:   ()             => downloadBlob(api.get(`/api/sukuk/contracts/template`, { responseType: "blob" }), `sukuk_contract_template.xlsx`),
  importContract:     (file, contractId, mode) => {
    const fd = new FormData(); fd.append("file", file);
    const params = {};
    if (contractId) params.contract_id = contractId;
    if (mode) params.mode = mode;
    return api.post(`/api/sukuk/contracts/import`, fd, { headers: { "Content-Type": "multipart/form-data" }, params });
  },
};

// v3.3.487 — Accounting module (Daftra integration)
// v3.3.488 — Added cost-center tree methods
export const accounting = {
  getConfig:        ()        => api.get(`/api/accounting/config`),
  updateConfig:     (data)    => api.put(`/api/accounting/config`, data),
  sync:             (data)    => api.post(`/api/accounting/sync`, data || {}),
  listTransactions: (params = {}) => api.get(`/api/accounting/transactions`, { params }),
  getTransaction:   (id)      => api.get(`/api/accounting/transactions/${id}`),
  listCostCenters:  (params = {}) => api.get(`/api/accounting/cost-centers`, { params }),
  listAccounts:     (params = {}) => api.get(`/api/accounting/accounts`, { params }),
  // v3.3.488 — Cost-center tree
  ccTreeList:       ()                => api.get(`/api/accounting/cc-tree`),
  ccTreeUnassigned: ()                => api.get(`/api/accounting/cc-tree/unassigned`),
  ccTreeCreate:     (data)            => api.post(`/api/accounting/cc-tree`, data),
  ccTreeUpdate:     (id, data)        => api.put(`/api/accounting/cc-tree/${id}`, data),
  ccTreeDelete:     (id)              => api.delete(`/api/accounting/cc-tree/${id}`),
  ccTreeReport:     (params = {})     => api.get(`/api/accounting/cc-tree/report`, { params }),
  // v3.3.504 — Reorder & move
  // v3.3.515 — Account mirror endpoints (parallel UX to cost-center ones)
  ccTreeAccountsUnassigned: () => api.get(`/api/accounting/cc-tree/accounts-unassigned`),
  ccTreeAccountsHidden:     () => api.get(`/api/accounting/cc-tree/accounts-hidden`),
  ccTreeAccountHide:        (accId) => api.post(`/api/accounting/cc-tree/account-hide/${accId}`),
  ccTreeAccountUnhide:      (accId) => api.post(`/api/accounting/cc-tree/account-unhide/${accId}`),
  ccTreeAccountHideBulk:    (ids) => api.post(`/api/accounting/cc-tree/account-hide-bulk`, { journal_account_ids: ids }),
  ccTreeAccountUnhideBulk:  (ids) => api.post(`/api/accounting/cc-tree/account-unhide-bulk`, { journal_account_ids: ids }),
  // v3.3.511 — Diagnostic tools
  inspectTransaction: (id) => api.get(`/api/accounting/inspect-transaction/${id}`),
  resyncTransaction:  (id) => api.post(`/api/accounting/resync-transaction/${id}`),
  // v3.3.514 — Duplicate detection & cleanup
  findDuplicates:     ()                 => api.get(`/api/accounting/find-duplicates`),
  cleanupDuplicates:  (body)             => api.post(`/api/accounting/cleanup-duplicates`, body),
  inspectJournal:     (journalNumber)    => api.get(`/api/accounting/inspect-journal/${encodeURIComponent(journalNumber)}`),
  // v3.3.510 — Detailed statement
  statement:        (params)          => api.get(`/api/accounting/statement`, { params }),
  statementExport:  (params)          => downloadBlob(api.get(`/api/accounting/statement/export`, { params, responseType: "blob" }), `statement_${params.id}_${new Date().toISOString().slice(0,10)}.xlsx`),
  // v3.3.556 — Tree node reference number (user-defined identifier)
  setTreeNodeRefNo:   (nodeId, refNo)   => api.put(`/api/accounting/cc-tree/${nodeId}/ref-no`, { ref_no: refNo }),
  getTreeByRefNo:     (refNo, params)   => api.get(`/api/accounting/cc-tree/by-ref/${encodeURIComponent(refNo)}`, { params }),
  listTreeRefs:       ()                => api.get(`/api/accounting/cc-tree/refs`),
  ccTreeReorder:    (id, direction)   => api.post(`/api/accounting/cc-tree/${id}/reorder`, { direction }),
  ccTreeMove:       (id, newParentId) => api.post(`/api/accounting/cc-tree/${id}/move`, { new_parent_id: newParentId }),
  // v3.3.496 — Hidden cost centers
  ccTreeHidden:     ()                => api.get(`/api/accounting/cc-tree/hidden`),
  ccTreeHide:       (ccId)            => api.post(`/api/accounting/cc-tree/hide/${ccId}`),
  ccTreeUnhide:     (ccId)            => api.post(`/api/accounting/cc-tree/unhide/${ccId}`),
  // v3.3.507 — Bulk operations
  ccTreeHideBulk:   (ids)             => api.post(`/api/accounting/cc-tree/hide-bulk`, { cost_center_ids: ids }),
  ccTreeUnhideBulk: (ids)             => api.post(`/api/accounting/cc-tree/unhide-bulk`, { cost_center_ids: ids }),
  ccTreeDeleteBulk: (nodeIds)         => api.post(`/api/accounting/cc-tree/delete-bulk`, { node_ids: nodeIds }),
  // v3.3.517 — Bulk classify (attach multiple cost-centers or accounts under one parent)
  ccTreeClassifyBulk: (body)          => api.post(`/api/accounting/cc-tree/classify-bulk`, body),
  // v3.3.519 — Nuclear option: wipe local and resync everything from Daftra
  wipeAndResync:    () => api.post(`/api/accounting/wipe-and-resync`, { confirm: true }),
  // v3.3.521 — Diagnose accounts (why are account totals zero?)
  diagnoseAccounts: () => api.get(`/api/accounting/diagnose-accounts`),
  // v3.3.522 — Find & fix orphaned account leaves (zero-tx leaves with name match)
  findOrphanedAccountLeaves: () => api.get(`/api/accounting/find-orphaned-account-leaves`),
  fixOrphanedAccountLeaves:  () => api.post(`/api/accounting/fix-orphaned-account-leaves`),
  // v3.3.524 — Probe Daftra entities to find one with ALL transactions (not just cost-center ones)
  probeDaftraEntities: () => api.get(`/api/accounting/probe-daftra-entities`),
  // v3.3.525 — Get a sample of journal_transaction rows for schema inspection
  probeJournalTransactionSample: () => api.get(`/api/accounting/probe-journal-transaction-sample`),
  // v3.3.526 — Full sync from journal_transaction (the complete entity with all 35,976 rows)
  wipeAndResyncFull: () => api.post(`/api/accounting/wipe-and-resync-full`, { confirm: true }),
  // v3.3.532 — Compare row count for a specific account between local DB and Daftra
  compareAccountRows: (accountId) => api.get(`/api/accounting/compare-account-rows`, { params: { account_id: accountId } }),
  // v3.3.535 — Diagnose drafts state (schema migration + stored count)
  diagnoseDrafts: () => api.get(`/api/accounting/diagnose-drafts`),
  // v3.3.539 — Relink cost_center_id on existing rows (fixes zeros in CC report without full resync)
  relinkCostCenters: () => api.post(`/api/accounting/relink-cost-centers`),
  // v3.3.499 — Export / import tree
  ccTreeExport:     ()                => downloadBlob(api.get(`/api/accounting/cc-tree/export`, { responseType: "blob" }), `cost_center_tree_${new Date().toISOString().slice(0,10)}.xlsx`),
  ccTreeImport:     (file)            => {
    const fd = new FormData(); fd.append("file", file);
    return api.post(`/api/accounting/cc-tree/import`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  },
  // v3.3.585 — Vouchers (سندات قبض/صرف)
  syncVouchers:     ()                => api.post(`/api/accounting/sync-vouchers`),
  syncRuns:         (limit)           => api.get(`/api/accounting/sync-runs`, { params: { limit: limit || 30 } }), // v3.4.646
  syncRun:          (id)              => api.get(`/api/accounting/sync-runs/${id}`),
  listVouchers:     (params = {})     => api.get(`/api/accounting/vouchers`, { params }),
  getVoucher:       (id)              => api.get(`/api/accounting/vouchers/${id}`),
  // v3.3.591 — link/unlink a voucher to a unit (4-step picker in UI)
  linkVoucherUnit:  (id, unitId)      => api.put(`/api/accounting/vouchers/${id}/link-unit`, { unit_id: unitId }),
  // v3.3.592 — bulk link vouchers ↔ units via Excel (respects current filters on export)
  exportVoucherLinkTemplate: (params = {}) => downloadBlob(api.get(`/api/accounting/vouchers/export-link-template`, { params, responseType: "blob" }), `vouchers_link_template_${new Date().toISOString().slice(0,10)}.xlsx`),
  importVoucherLinks: (file) => {
    const fd = new FormData(); fd.append("file", file);
    return api.post(`/api/accounting/vouchers/import-links`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  },
};

// v3.3.576 — Treasury (الخزينة المالية)
// Re-display of the local Daftra cache (cash boxes, banks, undeposited checks).
// v3.3.897 — تتبّع فتح ملفات تحديثات المشاريع
export const docTracking = {
  links:  (data)  => api.post("/api/track/links", data),
  stats:  (docId) => api.get(`/api/track/stats/${docId}`),
  byProject: (projectId, channel) => api.get(`/api/track/project/${projectId}`, { params: channel ? { channel } : {} }), // v3.4.304 — قناة
  views:  (docId) => api.get(`/api/track/views/${docId}`),
  toggle: (docId, enabled) => api.put(`/api/track/toggle/${docId}`, { enabled }),
};

// v3.3.922 — وارد العملاء من المصادر الخارجية
export const leadHooks = {
  config:  ()            => api.get("/api/lead-hooks/config"),
  list:    (params)      => api.get("/api/lead-hooks", { params }),
  stats:   ()            => api.get("/api/lead-hooks/stats"), // v3.4.176 — إحصائيات الوارد
  promote: (id)          => api.post(`/api/lead-hooks/${id}/promote`),
  dismiss: (id)          => api.post(`/api/lead-hooks/${id}/dismiss`),
  remove:  (id)          => api.delete(`/api/lead-hooks/${id}`),
  rotate:  (source)      => api.post(`/api/lead-hooks/config/${source}/rotate`),
  boardQr: (p, t)        => api.get("/api/lead-hooks/board-qr", { params: { p, ...(t ? { t } : {}) } }), // v3.4.579 — QR لوح المشروع
  boardQrs: ()           => api.get("/api/lead-hooks/board-qrs"), // v3.4.582 — رموز QR المحفوظة
  saveBoardQr: (p, t)    => api.post("/api/lead-hooks/board-qrs", { p, t }),
  deleteBoardQr: (id)    => api.delete(`/api/lead-hooks/board-qrs/${id}`),
  docsUrl: (dl)          => `${API_BASE}/api/lead-hooks/docs${dl ? "?dl=1" : ""}`, // v3.3.944 — دليل ربط API
  campaigns: (source)    => api.get("/api/lead-hooks/campaigns", { params: { source } }), // v3.3.947 — الحملات التسويقية
  adsConfig: ()          => api.get("/api/lead-hooks/ads-config"),        // v3.3.949 — ربط مدير إعلانات ميتا
  saveAdsConfig: (d)     => api.put("/api/lead-hooks/ads-config", d),
  adsInsights: (refresh) => api.get("/api/lead-hooks/ads-insights", { params: refresh ? { refresh: 1 } : {} }),
  adsInsightsTiktok: (refresh) => api.get("/api/lead-hooks/ads-insights-tiktok", { params: refresh ? { refresh: 1 } : {} }), // v3.3.950
  tiktokOauth: (d)   => api.post("/api/lead-hooks/tiktok-oauth", d), // v3.3.951 — تبديل auth_code بتوكن دائم
};

// v3.3.923 — إدارة الكول سنتر (سنترال Yeastar)
export const yeastar = {
  settings:     ()       => api.get("/api/yeastar/settings"),
  notes:        (key)    => api.get(`/api/yeastar/notes/${key}`), // v3.4.806 — بيانات إضافية (pbx | tg)
  saveNotes:    (key, text) => api.put(`/api/yeastar/notes/${key}`, { text }),
  saveSettings: (d)      => api.put("/api/yeastar/settings", d),
  status:       ()       => api.get("/api/yeastar/status"),
  extensions:   ()       => api.get("/api/yeastar/extensions"),
  cdr:          (params) => api.get("/api/yeastar/cdr", { params }),
  dial:         (d)      => api.post("/api/yeastar/dial", d),
  recordings:   (params) => api.get("/api/yeastar/recordings", { params }),
  recordingUrl: (id, dl) => `${API_BASE}/api/yeastar/recordings/download?id=${id}${dl ? "&dl=1" : ""}`,
  recordingFileUrl: (file, dl) => `${API_BASE}/api/yeastar/recordings/download?file=${encodeURIComponent(file)}${dl ? "&dl=1" : ""}`, // v3.3.926 — تشغيل تسجيل مكالمة من سجل CDR
  // v3.3.929 — إدارة التحويلات وتوجيه الشرائح
  extDetail:      (id)      => api.get(`/api/yeastar/extensions/${id}`),
  updateExt:      (id, d)   => api.put(`/api/yeastar/extensions/${id}`, d),
  welcomeEmail:   (id, d)   => api.post(`/api/yeastar/extensions/${id}/welcome-email`, d || {}),
  routing:        ()        => api.get("/api/yeastar/routing"),
  updateInbound:  (id, d)   => api.put(`/api/yeastar/inbound-routes/${id}`, d),
  updateOutbound: (id, d)   => api.put(`/api/yeastar/outbound-routes/${id}`, d),
  labels:         ()        => api.get("/api/yeastar/labels"),           // v3.3.930 — أرقام الشرائح/الخطوط
  saveLabel:      (key, phone) => api.put("/api/yeastar/labels", { key, phone }),
  ringGroups:     ()        => api.get("/api/yeastar/ring-groups"),      // v3.3.931 — مجموعات الرنين
  updateRingGroup:(id, d)   => api.put(`/api/yeastar/ring-groups/${id}`, d),
  inferRingGroups:(days)    => api.get("/api/yeastar/ring-groups/infer", { params: { days } }), // v3.4.804 — استنتاج الأعضاء من سجل المكالمات
  syncRingGroups: (d)       => api.post("/api/yeastar/ring-groups/sync-from-cdr", d),
  callIntake:     ()        => api.get("/api/yeastar/call-intake"), // v3.4.808 — إدخال المتصلين إلى CRM
  saveCallIntake: (d)       => api.put("/api/yeastar/call-intake", d),
  runCallIntake:  (days)    => api.post("/api/yeastar/call-intake/run", { days }),
};

// v3.3.939 — استعراض محادثات واتساب بزنس لكل الأرقام (تبويب الكول سنتر)
export const waBiz = {
  numbers:       (params) => api.get("/api/wa-business/numbers", { params }), // v3.4.180 — scope: marketing | company
  conversations: (params) => api.get("/api/wa-business/conversations", { params }),
  thread:        (phone, biz) => api.get(`/api/wa-business/thread/${encodeURIComponent(phone)}`, { params: biz && biz !== "all" ? { biz } : {} }), // v3.4.067 — مقصور على الرقم المختار
  renameNumber:  (display, name) => api.put(`/api/wa-business/numbers/${encodeURIComponent(display)}/name`, { name }), // v3.3.946
  assignees:     (biz)    => api.get("/api/wa-business/assignees", { params: { biz } }), // v3.4.161 — تحويل المحادثات
  assign:        (d)      => api.post("/api/wa-business/assign", d), // v3.4.161 — {biz, phone, portal_user_id|null}
  // v3.4.110 — واتساب المسوّقين الشخصي المربوط (تبويب «واتس المسوقين» — قراءة فقط)
  pwaSessions:      ()           => api.get("/api/portal/pwa-admin/sessions"),
  pwaConversations: (uid, q)     => api.get(`/api/portal/pwa-admin/${uid}/conversations`, { params: q ? { q } : {} }),
  pwaThread:        (uid, phone) => api.get(`/api/portal/pwa-admin/${uid}/thread/${encodeURIComponent(phone)}`),
  webhookDiagnostics: (d = {}) => api.post("/api/wa-business/webhook-diagnostics", d), // v3.4.032/036 — تشخيص وصول الرسائل (POST كي لا يمر التوكن بالـ URL)
  subscribeWabas: (d) => api.post("/api/wa-business/subscribe-wabas", d), // v3.4.035 — اشتراك الويبهوك بحسابات WABA
  registerNumber: (d) => api.post("/api/wa-business/register-number", d), // v3.4.037 — تسجيل رقم على تطبيقنا (فصل عن بيفاتيل)
  reply: (d) => api.post("/api/wa-business/reply", d), // v3.4.038 — رد نصي من تبويب المحادثات
  getSettings: () => api.get("/api/wa-business/settings"), // v3.4.039 — إعدادات ميتا من داخل النظام
  saveSettings: (d) => api.post("/api/wa-business/settings", d),
  metaNotes: () => api.get("/api/wa-business/meta-notes"), // v3.4.800
  esConfig: () => api.get("/api/wa-business/embedded-signup/config"), // v3.4.802
  saveEsConfig: (d) => api.put("/api/wa-business/embedded-signup/config", d),
  esFinish: (d) => api.post("/api/wa-business/embedded-signup/finish", d, { timeout: 120000 }),
  saveMetaNotes: (text) => api.put("/api/wa-business/meta-notes", { text }),
};

// v3.3.934 — رسائل SMS عبر جايتواي TG800
export const tgSms = {
  settings:     ()       => api.get("/api/tg/settings"),
  saveSettings: (d)      => api.put("/api/tg/settings", d),
  send:         (d)      => api.post("/api/tg/send", d),
  ussd:         (d)      => api.post("/api/tg/ussd", d),
  inbox:        (params) => api.get("/api/tg/inbox", { params }),
  outbox:       ()       => api.get("/api/tg/outbox"),
  removeInbox:  (id)     => api.delete(`/api/tg/inbox/${id}`),
};

export const treasury = {
  summary:        (params = {}) => api.get(`/api/treasury/summary`,  { params }),
  accounts:       (params = {}) => api.get(`/api/treasury/accounts`, { params }),
  movements:      (params = {}) => api.get(`/api/treasury/movements`,{ params }),
  trend:          (params = {}) => api.get(`/api/treasury/trend`,    { params }),
  accountDetails: (code, params = {}) => api.get(`/api/treasury/account/${encodeURIComponent(code)}/details`, { params }),
};


// v3.3.741 — حارس التكرار: الباكند يرد 409 duplicate عند وجود نفس الاسم/الجوال؛
// نعرض السجلات الموجودة ونسأل المستخدم قبل الإضافة القسرية (force)
export const addWithDupGuard = async (addFn, data) => {
  try {
    return await addFn(data);
  } catch (e) {
    if (e.response?.status === 409 && e.response.data?.duplicate) {
      const ex = (e.response.data.existing || [])
        .map(x => `#${x.id} ${x.name}${x.phone ? " — " + x.phone : ""}`).join("\n");
      const ok = window.confirm(`⚠️ ${e.response.data.error}:\n${ex}\n\nهل تريد الإضافة على أي حال؟`);
      if (ok) return await addFn({ ...data, force: true });
      const err = new Error("duplicate_cancelled");
      err.cancelled = true;
      err.response = { data: { error: "أُلغيت الإضافة — السجل موجود مسبقًا" } };
      throw err;
    }
    throw e;
  }
};

// v3.4.202 — البث المجدول عبر الخادم (تأخير + حد يومي + استكمال تلقائي)
// v3.4.328 — Chairman Office: الإيميلات
export const chairmanMail = {
  mailboxes: () => api.get("/api/chairman-mail/mailboxes"),
  addMailbox: (d) => api.post("/api/chairman-mail/mailboxes", d),
  removeMailbox: (id) => api.delete(`/api/chairman-mail/mailboxes/${id}`),
  testMailbox: (id) => api.post(`/api/chairman-mail/mailboxes/${id}/test`, {}, { timeout: 30000 }),
  messages: (params) => api.get("/api/chairman-mail/messages", { params, timeout: 60000 }),
  message: (mailbox, id) => api.get(`/api/chairman-mail/messages/${encodeURIComponent(mailbox)}/${id}`, { timeout: 30000 }),
  attachmentUrl: (mailbox, id, a) => `${API_BASE}/api/chairman-mail/messages/${encodeURIComponent(mailbox)}/${id}/attachments/${a.id}?name=${encodeURIComponent(a.filename || "file")}&mime=${encodeURIComponent(a.mime || "")}`,
  markRead: (mailbox, id, unread) => api.post(`/api/chairman-mail/messages/${encodeURIComponent(mailbox)}/${id}/read`, { unread: !!unread }),
  star: (mailbox, id, starred) => api.post(`/api/chairman-mail/messages/${encodeURIComponent(mailbox)}/${id}/star`, { starred: !!starred }),
  labels: (mailbox, fresh) => api.get(`/api/chairman-mail/mailboxes/${encodeURIComponent(mailbox)}/labels`, { params: fresh ? { fresh: 1 } : {}, timeout: 30000 }), // v3.4.329
  archive: (mailbox, id) => api.post(`/api/chairman-mail/messages/${encodeURIComponent(mailbox)}/${id}/archive`, {}), // v3.4.329
  trash: (mailbox, id, restore) => api.post(`/api/chairman-mail/messages/${encodeURIComponent(mailbox)}/${id}/trash`, { restore: !!restore }), // v3.4.329
  reply: (mailbox, id, d) => api.post(`/api/chairman-mail/messages/${encodeURIComponent(mailbox)}/${id}/reply`, d, { timeout: 120000 }),
  send: (d) => api.post("/api/chairman-mail/send", d, { timeout: 120000 }),
  forward: (mailbox, id, d) => api.post(`/api/chairman-mail/messages/${encodeURIComponent(mailbox)}/${id}/forward`, d, { timeout: 120000 }), // v3.4.338
  updateMailbox: (id, d) => api.patch(`/api/chairman-mail/mailboxes/${id}`, d), // v3.4.338
  msSettings: () => api.get("/api/chairman-mail/ms/settings"), // v3.4.336 — Hotmail/Outlook
  saveMsSettings: (d) => api.post("/api/chairman-mail/ms/settings", d),
  msConnectUrl: (label, color) => `${API_BASE}/api/chairman-mail/ms/connect?label=${encodeURIComponent(label || "")}&color=${encodeURIComponent(color || "")}`,
};
// v3.4.339 — التقويم الموحّد لمكتب رئيس المجلس
export const chairmanCal = {
  events: (params) => api.get("/api/chairman-calendar/events", { params, timeout: 60000 }),
  create: (d) => api.post("/api/chairman-calendar/events", d, { timeout: 30000 }),
  update: (mailbox, id, d) => api.patch(`/api/chairman-calendar/events/${encodeURIComponent(mailbox)}/${encodeURIComponent(id)}`, d, { timeout: 30000 }),
  remove: (mailbox, id) => api.delete(`/api/chairman-calendar/events/${encodeURIComponent(mailbox)}/${encodeURIComponent(id)}`, { timeout: 30000 }),
};
// v3.4.345 — جهات اتصال الرئيس
export const chairmanContacts = {
  list: (params) => api.get("/api/chairman-contacts", { params }),
  create: (d) => api.post("/api/chairman-contacts", d),
  update: (id, d) => api.patch(`/api/chairman-contacts/${id}`, d),
  bulkDelete: (ids) => api.post("/api/chairman-contacts/bulk-delete", { ids }),
  importRows: (d) => api.post("/api/chairman-contacts/import", d, { timeout: 180000 }),
  waChats: (session) => api.get(`/api/chairman-contacts/wa-chats/${session}`),
  groups: () => api.get("/api/chairman-contacts/groups"),
  createGroup: (d) => api.post("/api/chairman-contacts/groups", d),
  updateGroup: (id, d) => api.patch(`/api/chairman-contacts/groups/${id}`, d),
  deleteGroup: (id) => api.delete(`/api/chairman-contacts/groups/${id}`),
  members: (id, d) => api.post(`/api/chairman-contacts/groups/${id}/members`, d),
  upload: (fd) => api.post("/api/chairman-contacts/upload", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 }),
  send: (d) => api.post("/api/chairman-contacts/send", d),
};
// v3.4.311 — الرسائل الجاهزة للإرسال
// v3.4.361 — مكتبة الميديا والجرافيك
export const mediaLibrary = {
  overview: () => api.get("/api/media-library/overview"),
  library: (p) => api.get("/api/media-library/library", { params: p && typeof p === "object" ? p : { project_id: p } }), // v3.4.389 — { project_id } أو { library_id }
  createLibrary: (d) => api.post("/api/media-library/libraries", d), // v3.4.389 — مكتبات رئيسية مخصّصة
  updateLibrary: (id, d) => api.patch(`/api/media-library/libraries/${id}`, d),
  deleteLibrary: (id) => api.delete(`/api/media-library/libraries/${id}`),
  createSection: (d) => api.post("/api/media-library/sections", d),
  updateSection: (id, d) => api.patch(`/api/media-library/sections/${id}`, d),
  renameSection: (d) => api.put("/api/media-library/sections/rename", d), // v3.4.453 — أساسي أو مخصّص
  deleteSection: (id) => api.delete(`/api/media-library/sections/${id}`),
  upload: (fd, onPct) => api.post("/api/media-library/items/upload", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0, onUploadProgress: (e) => onPct && e.total && onPct(Math.round(e.loaded * 100 / e.total)) }),
  addLink: (d) => api.post("/api/media-library/items/link", d),
  updateItem: (id, d) => api.patch(`/api/media-library/items/${id}`, d),
  deleteItem: (id) => api.delete(`/api/media-library/items/${id}`),
  reorder: (ids) => api.post("/api/media-library/items/reorder", { ids }),
};
// v3.4.764 — استوديو الذكاء الاصطناعي للسوشل ميديا
export const aiStudio = {
  overview: () => api.get("/api/ai-studio/overview"),
  tags: () => api.get("/api/ai-studio/tags"),
  describe: (id, force) => api.post(`/api/ai-studio/describe/${id}`, { force: !!force }, { timeout: 120000 }),
  describeMissing: (kind) => api.post("/api/ai-studio/describe-missing", { kind }, { timeout: 0 }),
  generatePost: (d) => api.post("/api/ai-studio/generate-post", d, { timeout: 0 }),
  post: (id) => api.get(`/api/ai-studio/posts/${id}`),
  deletePost: (id) => api.delete(`/api/ai-studio/posts/${id}`),
  createNote: (d) => api.post("/api/ai-studio/notes", d),
  updateNote: (id, d) => api.put(`/api/ai-studio/notes/${id}`, d),
  setTags: (id, tags) => api.put(`/api/ai-studio/items/${id}/tags`, { tags }),
  autoSort: (ids) => api.post("/api/ai-studio/auto-sort", { ids: ids || [] }, { timeout: 0 }), // v3.4.766
  publicLink: () => api.get("/api/ai-studio/public-link"), // v3.4.765
  rotatePublicLink: () => api.post("/api/ai-studio/public-link/rotate"),
  disablePublicLink: () => api.delete("/api/ai-studio/public-link"),
};
// v3.4.360 — معارض الصور برابط واحد
export const waGalleries = {
  create: (d) => api.post("/api/g", d),
  list: (params) => api.get("/api/g", { params }),
};
export const waPresets = {
  list: (projectId) => api.get("/api/wa-presets", { params: projectId ? { project_id: projectId } : {} }),
  create: (d) => api.post("/api/wa-presets", d),
  update: (id, d) => api.put(`/api/wa-presets/${id}`, d),
  remove: (id) => api.delete(`/api/wa-presets/${id}`),
  send: (id, override) => api.post(`/api/wa-presets/${id}/send`, override || {}), // v3.4.325 — override: مستلمون جدد
  overview: () => api.get("/api/wa-presets/overview"), // v3.4.347
  schedules: (id) => api.get(`/api/wa-presets/${id}/schedules`), // v3.4.352 — الإرسالات الدورية
  createSchedule: (id, d) => api.post(`/api/wa-presets/${id}/schedules`, d),
  updateSchedule: (sid, d) => api.put(`/api/wa-presets/schedules/${sid}`, d),
  deleteSchedule: (sid) => api.delete(`/api/wa-presets/schedules/${sid}`),
  runSchedule: (sid) => api.post(`/api/wa-presets/schedules/${sid}/run-now`),
  mediaLibrary: (pid) => api.get(`/api/wa-presets/media-library/${pid}`), // v3.4.360 — ملفات المشروع + وسائط الشاشة
  approve: (id, is_approved) => api.patch(`/api/wa-presets/${id}/approve`, { is_approved }),
  copyToCompany: (id) => api.post(`/api/wa-presets/${id}/copy-to-company`),
};
// v3.4.490 — نماذج التواصل مع العملاء
export const clientPresets = {
  list: (projectId) => api.get("/api/client-presets", { params: { project_id: projectId } }),
  recipients: (projectId) => api.get(`/api/client-presets/recipients/${projectId}`),
  create: (d) => api.post("/api/client-presets", d),
  update: (id, d) => api.put(`/api/client-presets/${id}`, d),
  remove: (id) => api.delete(`/api/client-presets/${id}`),
  send: (id, audience) => api.post(`/api/client-presets/${id}/send`, { audience }),
  schedules: (id) => api.get(`/api/client-presets/${id}/schedules`),
  createSchedule: (id, d) => api.post(`/api/client-presets/${id}/schedules`, d),
  updateSchedule: (sid, d) => api.put(`/api/client-presets/schedules/${sid}`, d),
  deleteSchedule: (sid) => api.delete(`/api/client-presets/schedules/${sid}`),
  runSchedule: (sid) => api.post(`/api/client-presets/schedules/${sid}/run-now`),
};

export const waJobs = {
  settings: () => api.get("/api/whatsapp-jobs/settings"),
  saveSettings: (data) => api.put("/api/whatsapp-jobs/settings", data),
  admin: () => api.get("/api/whatsapp-jobs/admin"), // v3.4.513 — صفحة «إدارة الواتس»
  quota: (session) => api.get(`/api/whatsapp-jobs/quota/${session}`),
  create: (data) => api.post("/api/whatsapp-jobs/jobs", data),
  list: (params = {}) => api.get("/api/whatsapp-jobs/jobs", { params }),
  get: (id) => api.get(`/api/whatsapp-jobs/jobs/${id}`),
  pause: (id) => api.post(`/api/whatsapp-jobs/jobs/${id}/pause`),
  resume: (id) => api.post(`/api/whatsapp-jobs/jobs/${id}/resume`),
  cancel: (id) => api.post(`/api/whatsapp-jobs/jobs/${id}/cancel`),
};

// v3.4.202 — العروض التسويقية (عروض على وحدات المشاريع + بروشور + مشاركة مع المسوقين)
export const marketingOffers = {
  list: (params = {}) => api.get("/api/marketing-offers", { params }),
  get: (id) => api.get(`/api/marketing-offers/${id}`),
  create: (data) => api.post("/api/marketing-offers", data),
  update: (id, data) => api.put(`/api/marketing-offers/${id}`, data),
  remove: (id) => api.delete(`/api/marketing-offers/${id}`),
  projectUnits: (project_id) => api.get("/api/marketing-offers/project-units", { params: { project_id } }),
  uploadBrochure: (id, file) => { const fd = new FormData(); fd.append("file", file); return api.post(`/api/marketing-offers/${id}/brochure`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 300000 }); },
  removeBrochure: (id) => api.delete(`/api/marketing-offers/${id}/brochure`),
  // v3.4.226 — اختيار بروشور الحملة من مواد المشروع المرفوعة
  projectDocuments: (project_id) => api.get("/api/marketing-offers/project-documents", { params: { project_id } }),
  brochureFromDocument: (id, document_id) => api.post(`/api/marketing-offers/${id}/brochure-from-document`, { document_id }),
  message: (id) => api.get(`/api/marketing-offers/${id}/message`),
  saveMessage: (id, d) => api.put(`/api/marketing-offers/${id}/message`, d), // v3.4.315
  share: (id, data) => api.post(`/api/marketing-offers/${id}/share`, data),
};

// v3.4.207 — قائمة المهام للموظفين
export const staffTasks = {
  list: (params = {}) => api.get("/api/staff-tasks", { params }),
  get: (id) => api.get(`/api/staff-tasks/${id}`),
  users: () => api.get("/api/staff-tasks/users"),
  summary: () => api.get("/api/staff-tasks/summary"),
  create: (data) => api.post("/api/staff-tasks", data),
  update: (id, data) => api.put(`/api/staff-tasks/${id}`, data),
  status: (id, action, note) => api.post(`/api/staff-tasks/${id}/status`, { action, note }),
  addNote: (id, note) => api.post(`/api/staff-tasks/${id}/notes`, { note }),
  remove: (id) => api.delete(`/api/staff-tasks/${id}`),
};

// v3.4.634 — بيانات وافي للمشروع (تُسحب لعقود وافي)
export const projectWafi = {
  get: (pid) => api.get(`/api/contracts/wafi-defaults/${pid}`),
  save: (pid, data) => api.put(`/api/contracts/wafi-defaults/${pid}`, { data }),
};
// v3.4.621 — عقود التوريدات والخدمات الاستشارية
export const supplyContracts = {
  meta: () => api.get("/api/supply-contracts/meta"),
  list: (params = {}) => api.get("/api/supply-contracts/contracts", { params }),
  get: (id) => api.get(`/api/supply-contracts/contracts/${id}`),
  create: (d) => api.post("/api/supply-contracts/contracts", d),
  update: (id, d) => api.put(`/api/supply-contracts/contracts/${id}`, d),
  remove: (id) => api.delete(`/api/supply-contracts/contracts/${id}`),
  saveSchedule: (id, rows) => api.put(`/api/supply-contracts/contracts/${id}/schedule`, { rows }),
  upload: (id, file, category, title) => { const fd = new FormData(); fd.append("file", file); fd.append("category", category); if (title) fd.append("title", title); return api.post(`/api/supply-contracts/contracts/${id}/files`, fd, { headers: { "Content-Type": "multipart/form-data" } }); },
  removeFile: (fid) => api.delete(`/api/supply-contracts/files/${fid}`),
  orders: (params = {}) => api.get("/api/supply-contracts/orders", { params }),
  createOrder: (id, d) => api.post(`/api/supply-contracts/contracts/${id}/orders`, d),
  approve: (oid) => api.post(`/api/supply-contracts/orders/${oid}/approve`),
  pay: (oid, ref) => api.post(`/api/supply-contracts/orders/${oid}/pay`, { ref }),
  reject: (oid, reason) => api.post(`/api/supply-contracts/orders/${oid}/reject`, { reason }),
  removeOrder: (oid) => api.delete(`/api/supply-contracts/orders/${oid}`),
};
